function deleteLocalStorageKeyWUS(key) {
    if (typeof localStorage !== 'undefined' && localStorage.getItem(key) !== null) {
      localStorage.removeItem(key);
    }
}

function hasParentWithClass(element, className) {
    while (element) {
        if (element.classList && element.classList.contains(className)) {
            return element;
        }
        element = element.parentElement;
    }
    return null;
}

function isValidDateWUS(date) {
    return date instanceof Date && !isNaN(date.getTime());
}

function observeInViewport(
    element,
    {
      onAppear,
      onDisappear,
      threshold = 0,
      rootMargin = '0px',
    } = {}
  ) {
    if (!element) {
      throw new Error('Element is required');
    }
  
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onAppear && onAppear(entry);
        } else {
          onDisappear && onDisappear(entry);
        }
      },
      {
        threshold,
        rootMargin,
      }
    );
  
    observer.observe(element);
  
    return () => observer.disconnect();
}
  

var wus = {}

let startY = 0;

wus.canRunInterval = null
wus.currentFloatingBIW = null
wus.alreadyUsedBIWProduct = false
wus.floatingBIWInterval = null
wus.startedFloatingBIW = false
wus.floatingBIWMode = ""
wus.currentProduct = null
wus.floatingBIWProduct = null
wus.currentMainProduts = null
wus.mainProductATCClicked = false
window.MAIN_PRODUCT_TEMPLATE_ID = null

wus.log = function(data) {
    console.log("[WUS-INFO]", data)
}

wus.canRun = function() {
    var valid = true

    if (!document.getElementById("main")) {
        valid = false
    }

    if (!window.meta) {
        valid = false
    }

    return valid
}

wus.isMobileScreen = function() {
    return window.innerWidth < 700
}

wus.handleMenuItemsLeave = function() {
    if (wus.isMobileScreen()) {
        return
    }

    var menuItems = document.querySelectorAll("nav.header__link-list.wrap ul li [is=mega-menu-disclosure]")

    for (var i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener('mouseleave', handleMouseLeave);
    }

    function handleMouseLeave(e) {
        var elem = e.target;
        elem.removeAttribute("open")

        var megaMenu = elem.querySelector(".mega-menu")
        megaMenu.style["opacity"] = "0"
    }
}

wus.handleAnnouncementBarLinks = function() {
    var abLinks = document.querySelectorAll(".announcement-bar__item p a")

    for (var i = 0; i < abLinks.length; i++) {
        var link = abLinks[i]
        
        if (link.getAttribute("href").includes("onelink")) {
            continue    
        }

        abLinks[i].addEventListener('click', function(e) {
            e.preventDefault();
        });
    }
}

wus.startPlaceholderTyping = function(inputElem, textList, prefix) {
    let textIndex = 0;
    let blinkInterval;
  
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  
    function isInputFocused() {
        return document.activeElement === inputElem;
    }

    function startBlinkingCursor(baseText) {
        let visible = true;
        if (isInputFocused()) {
            inputElem.placeholder = baseText;
            return;
        }
    
        blinkInterval = setInterval(() => {
            if (isInputFocused()) {
                inputElem.placeholder = baseText;
                return;
            }
        
            inputElem.placeholder = baseText + (visible ? "|" : "");
            visible = !visible;
        }, 200);
    }
  
    function stopBlinkingCursor() {
      clearInterval(blinkInterval);
    }
  
    async function typeText(suffix) {
        for (let i = 0; i <= suffix.length; i++) {
            inputElem.placeholder = prefix + suffix.slice(0, i);
            await sleep(100);
        }
    }
  
    async function deleteText(suffix) {
        for (let i = suffix.length; i >= 0; i--) {
            inputElem.placeholder = prefix + suffix.slice(0, i);
            await sleep(50);
        }
    }
  
    async function loop() {
        while (true) {
            const suffix = textList[textIndex];
            await typeText(suffix);
            startBlinkingCursor(prefix + suffix);
            await sleep(1000); 
            stopBlinkingCursor();
            await deleteText(suffix);
            startBlinkingCursor(prefix);
            await sleep(1000);
            stopBlinkingCursor();
            textIndex = (textIndex + 1) % textList.length;
        }
    }
  
    loop();
}

wus.handleSearchPlaceholder = function() {
    let inputElem = document.querySelector("input[name='q']");

    if (!inputElem) {
        setTimeout(function() {
            wus.handleSearchPlaceholder();
        }, 1000)
        return
    }

    let searchPlaceholder = "Search for "

    let textList = [
        "...",
        "Lifestyle Shoes",
        "Running Shoes",
        "Training Shoes",
        "T-shirt",
        "Racket",
        "Slides",
        "Soccer Shoes",
        "Shorts",
        "Pants",
        "Basketball Shoes",
        "Tennis Shoes",
        "Whey Protein",
        "Leggings",
        "Tank Top",
        "Tracksuit",
        "Duffle Bag",
        "Clog",
        "Socks",
        "Backpack",
        "Swimwear"
    ]

    if (wus.isRTL()) {
        textList = [
            "...",
            "حذاء للاستخدام اليومي",
            "حذاء جري",
            "حذاء تدريب",
            "تيشيرت",
            "مضرب",
            "شباشب",
            "حذاء كرة القدم",
            "شورتات",
            "بنطلونات",
            "حذاء كرة سلة",
            "حذاء تنس",
            "واي بروتين",
            "ليجنز",
            "تانك توب",
            "بدلة رياضية",
            "شنطة دافل",
            "كلوجز",
            "شرابات",
            "شنطة ظهر",
            "ملابس سباحة"
        ]

        searchPlaceholder = "ابحث عن "
    }

    wus.startPlaceholderTyping(inputElem, textList, searchPlaceholder)
}
  

wus.handleAccesoriesLink = function() {
    var elem = document.querySelector('a[href*="custom/accessories"]')
    var elemSummary = document.querySelector('[data-url*="custom/accessories"]')
    
    if (elem) {
        elem.href = "#"

        elem.addEventListener('click', function(e) {
            e.preventDefault();
        });
    }

    if (elemSummary) {
        elemSummary.removeAttribute("data-url")
    }
}

wus.fetchProductJSON = async function(productHandle) {
    try {
        let url = "/products/" + productHandle + ".json"
        const response = await fetch(url);
        if (!response.ok) {
            return null
        }
        const data = await response.json();
        return data
    } catch (error) {
        return null
    }
}

wus.getProductHandle = function() {
    let elem = document.getElementById("wus-biw-product-handle")
    let handle = null

    if (elem) {
        handle =  elem.getAttribute("data-product-handle")
    }

    return handle
}

wus.getProductDirectMatchHandle = function() {
    let elem = document.getElementById("wus-biw-direct-match")
    let handle = null

    if (elem) {
        handle = elem.getAttribute("data-direct-match")
    }

    return handle
}

wus.fetchProductMatch = async function(productDirectMatch) {
    let products = await wus.fetchProductsByType(productDirectMatch, false, true)
    if (!(products !== null && products.length > 0)) {
        return null
    }
    return products[0]
}

// TO BE REMOVED
wus.getProductsRecomBIW = async function() {
    try {
        let url = document.getElementById("wus-biw-recoms").getAttribute("data-url")
        const response = await fetch(url);
        if (!response.ok) {
            return null
        }
        const data = await response.json();
        return data
    } catch (error) {
        return null
    }
}

wus.getSuggestedProductByType = async function(productType, gender, sport, vendor, productObj) {
    let products = await wus.fetchProductsByTypeSearch(productType, true, gender, sport, vendor, productObj)

    // if (!(products !== null && products.length > 0)) {
    //     return null;
    // }

    if (!(products !== null && products.length > 0)) {
        //products = await wus.fetchProductsByTypeSearch(productType, true)
        if (!(products !== null && products.length > 0)) {
            return null
        }
    }

    let product = products[Math.floor(Math.random() * products.length)]
    return product
}

wus.fetchProductsByType = async function(productType, includeVendor, onlySKU) {
    try {
        let query = productType;

        //let vendor = document.getElementById("wus-biw-product-vendor").getAttribute("data-product-vendor")
        let vendor = ""

        if (wus.floatingBIWProduct && wus.floatingBIWProduct.vendor) {
            vendor = wus.floatingBIWProduct.vendor
        }

        if (typeof vendor === "string" && vendor.length > 0) {
            if (includeVendor) {
                query = vendor + " " + productType
            }
        }

        let url = "/search/suggest.json?q=" + query + "&resources[type]=product&resources[options][unavailable_products]=hide"

        if (onlySKU) {
            url += "&resources[limit]=1&resources[options][fields]=variants.sku"
        } else {
            url += "&resources[limit]=10&resources[options][fields]=product_type,vendor,variants.title"
        }
        

        const response = await fetch(url);
        if (!response.ok) {
            return null
        }
        const data = await response.json();

        if (!(data.resources && data.resources.results && data.resources.results.products)) {
            return null
        }

        return data.resources.results.products
    } catch (error) {
        console.log(error)
        return null
    }
}

wus.getImageSrcWithVersion = function(currentImageSrc) {
    const url = currentImageSrc

    const [baseUrl, queryString] = url.split('?');

    let desiredParams = [];

    if (queryString) {
        const params = queryString.split('&');

        desiredParams = params.filter(param => param.startsWith('v='));
    }

    return desiredParams.length > 0 ? `${baseUrl}?${desiredParams.join('&')}` : baseUrl;
}

wus.handlePricesFromHTML = function(priceElem) {
    priceElem.querySelector("span").remove()
    const priceNumbers = priceElem.textContent.trim().replace(/[^\d.-]/g, '');
    return parseFloat(priceNumbers).toString();
}

wus.fetchProductsByTypeSearch = async function(productType, includeVendor, gender, sport, vendor, productObj) {
    try {
        let paramsArray = []

        let searchQueryArr = []
        let searchQuery = ""

        var specialBrands = ["nike", "adidas", "on", "asics", "wilson", "converse", "crocs", "babolat"]

        if (includeVendor) {
            var isValid = true
            if (typeof vendor === "string") {
                if (productType.toLowerCase() === "socks" && 
                      sport && sport.toLocaleLowerCase() === "football" &&
                      vendor.toLocaleLowerCase() === "adidas") {
                    isValid = false
                }

                if (isValid) {
                    searchQueryArr.push(vendor)
                }
            } else {
                if (productType.toLowerCase() === "socks") {
                    if (specialBrands.includes(productObj.vendor.toLocaleLowerCase())) {
                        searchQueryArr.push("adidas")
                    }
                }
            }
        }

        if (typeof sport === "string") {
            searchQueryArr.push(sport)
        }

        if (typeof gender === "string" && gender.length > 0) {
            if (gender !== "Unisex" && gender !== "Kids") {
                searchQueryArr.push(gender)
            }
        }

        if (productType.toLowerCase() === "socks" && wus.isLifeStyleProduct(productObj)) {
            searchQueryArr.push("everyday thing")
        }

        searchQueryArr.push(productType)

        searchQuery = searchQueryArr.join(" ");

        //console.log(searchQuery)

        paramsArray.push("q=" + searchQuery)
        
        paramsArray.push("type=product")
        paramsArray.push("sort_by=relevance")

        paramsArray.push("filter.p.product_type=" + productType)
        paramsArray.push("filter.v.availability=1")

        if (typeof gender === "string" && gender.length > 0) {
            if (gender === "Kids") {
                if (productType.toLowerCase() !== "socks") {
                    paramsArray.push("filter.p.m.my_fields.gender=" + gender)
                }
            }

            if (window.wus.currentProduct && window.wus.currentProduct.product_type === "Hijab") {
                paramsArray.push("filter.p.m.my_fields.gender=Women")
            }
        }

        let params = paramsArray.join("&")

        let url = "/search?" + params

        const response = await fetch(url);
        
        //console.log(url)

        if (!response.ok) {
            return null
        }
        
        const htmlData = await response.text();

        if (!(typeof htmlData === "string" && htmlData.length > 0)) {
            return null
        }

        const parser = new DOMParser();
        const htmlObj = parser.parseFromString(htmlData, 'text/html');

        let productCardsElems = htmlObj.querySelectorAll("product-card");

        let products = []

        for (var i = 0; i < productCardsElems.length; i++) {
            var productCardElem = productCardsElems[i]
            
            var product = {}

            let handle = productCardElem.getAttribute("handle")
            let productId = productCardElem.getAttribute("product-id")

            let primaryImage = productCardElem.querySelector(".product-card__image--primary")
            let secondaryImage = productCardElem.querySelector(".product-card__image--secondary")
            let vendorElem = productCardElem.querySelector(".product-card__info a.text-xs.link-faded")
            let titleElem = productCardElem.querySelector(".product-card__title a")
            let tagsElem = productCardElem.querySelectorAll(".product-card__badge-list .badge")
            let priceElem = productCardElem.querySelector("sale-price")
            let comparePriceElem = productCardElem.querySelector("compare-at-price")

            product.handle = handle
            product.id = productId
            product.tags = []

            if (primaryImage) {
                product.image = wus.getImageSrcWithVersion(primaryImage.getAttribute("src"))
            }

            if (secondaryImage) {
                product.secondImage = wus.getImageSrcWithVersion(secondaryImage.getAttribute("src"))
            }

            if (vendorElem) {
                product.vendor = vendorElem.innerHTML.trim()
            }

            if (titleElem) {
                product.title = titleElem.innerHTML.trim()
            }

            if (tagsElem.length > 0) {
                for (var y = 0; y < tagsElem.length; y++) {
                    product.tags.push(tagsElem[y].innerHTML)
                }
            }

            if (comparePriceElem) {
                product.compare_at_price_max = wus.handlePricesFromHTML(comparePriceElem);
            } else {
                product.compare_at_price_max = "0.00"
            }

            product.price_max = wus.handlePricesFromHTML(priceElem);
            products.push(product)

            if (products.length >= 4) {
                break
            }
        }

        return products
    } catch (error) {
        console.log(error)
        return null
    }
}

wus.handleProductBIWFloating = async function(floatingElem) {   
    document.querySelector("html").classList.add("wus-biw-f-here")
    wus.currentFloatingBIW = floatingElem
}

wus.monitorATCBIW = function() {
    var elem = document.querySelector(".quick-buy-drawer.show-close-cursor .quick-buy-drawer__info .banner--success")

    if (elem) {
        wus.openFloatingBIW()
    } else {
        wus.closeFloatingBIW()
    }
}

wus.monitorGlobalBIW = function() {
    if (wus.floatingBIWInterval) {
        return
    }

    wus.floatingBIWInterval = setInterval(function() {
        wus.monitorATCBIW()
    }, 10)
}

wus.openFloatingBIW = function() {
    if (!wus.currentFloatingBIW) {
        return
    }

    if (wus.currentFloatingBIW.classList.contains("biw-opened")) {
        return
    }

    if (wus.alreadyUsedBIWProduct) {
        return
    }

    if (!wus.currentFloatingBIW.classList.contains("wus-biw-has-products")) {
        return
    }

    wus.currentFloatingBIW.classList.remove("biw-closed")
    wus.currentFloatingBIW.classList.add("biw-opened")

    wus.currentFloatingBIW.style.setProperty("display", "flow-root", "important")
    setTimeout(function() {
        if (wus.isMobileScreen()) {
            var drawer = document.querySelector(".quick-buy-drawer.show-close-cursor")
            var bottom = drawer.clientHeight - 30
            wus.currentFloatingBIW.style.setProperty("bottom", bottom + "px");
        }
        
        wus.currentFloatingBIW.style.setProperty("opacity", "1")
    }, 500)
}

wus.closeFloatingBIW = function() {
    if (!wus.currentFloatingBIW) {
        return
    }

    if (!wus.currentFloatingBIW.classList.contains("biw-opened")) {
        return
    }

    wus.currentFloatingBIW.classList.remove("biw-opened")
    wus.currentFloatingBIW.style.setProperty("opacity", "0")

    wus.currentFloatingBIW.classList.remove("wus-biw-has-products")

    setTimeout(function() {
        wus.currentFloatingBIW.style.setProperty("display", "none", "important")
        wus.startedFloatingBIW = false
        wus.currentFloatingBIW.classList.add("biw-closed")
        wus.floatingBIWProduct = null
    }, 200)
}

wus.isFloatingBIWOpen = function() {
    if (wus.currentFloatingBIW && wus.currentFloatingBIW.classList.contains("biw-opened")) {
        return true
    }

    return false
}

wus.handleProductsBIW = async function() {
    var biwElems = document.querySelectorAll(".wus-biw-main");

    if (wus.isProductPage()) {
        let productHandle = wus.getProductHandle()
        for (var i = 0; i < biwElems.length; i++) {
            var elem = biwElems[i]
            wus.handleProductBuyItWith(elem, productHandle, true)
        }
    }

    if (biwElems.length > 0) {
        wus.monitorGlobalBIW()
    }

    function handleHorQuickATC(quickElem) {
        wus.alreadyUsedBIWProduct = false
        var elem = document.querySelector(".shopify-section--wus-biw-f .wus-biw-main");
        
        if (!elem) {
            return
        }

        var productCardElem = quickElem.closest(".horizontal-product")
        var quickDrawerElem = productCardElem.querySelector("quick-buy-drawer")

        if (!quickDrawerElem) {
            return
        }

        var productHandle = quickDrawerElem.getAttribute("handle")

        if (typeof productHandle === "string" && productHandle.includes("?")) {
            var productHandleArr = productHandle.split("?")
            if (typeof productHandleArr[0] === "string") {
                productHandle = productHandleArr[0]
            }
        }
        
        wus.handleProductBuyItWith(elem, productHandle, false)
    }

    function handleBiwNavClick(elem) {
        var eventValue = ""
        try {
            var productCardElem = elem.closest("product-card.product-card")
            var productHandle = productCardElem.getAttribute("handle")
            eventValue = productHandle
        } catch(e) {
            console.error(e)
            eventValue = ""
        }
        
        wus.sendEventGA("wus_biw_nav", "wus_biw", "", eventValue);
    }

    function handleQuickATC(quickElem) {
        var biwFloatingElem = quickElem.closest(".shopify-section--wus-biw-f")
        if (biwFloatingElem) {
            wus.alreadyUsedBIWProduct = true
            setTimeout(function() {
                var closeElem = document.querySelector(".quick-buy-drawer.show-close-cursor")
                if (closeElem) {
                    closeElem.shadowRoot.querySelector("[part='outside-close-button']").click()
                }
            }, 100);

            try {
                var productCardElem = quickElem.closest("product-card.product-card")
                var productHandle = productCardElem.getAttribute("handle")

                var eventValue = productHandle

                if (wus.floatingBIWProduct && typeof wus.floatingBIWProduct.handle === "string") {
                    //eventValue += "__" + wus.floatingBIWProduct.handle
                }

                wus.sendEventGA("wus_biw_qatc", "wus_biw", "", eventValue);
            } catch(e) {
                console.error(e)
            }
            
            return
        }
        
        wus.alreadyUsedBIWProduct = false

        var elem = document.querySelector(".shopify-section--wus-biw-f .wus-biw-main");
        
        if (!elem) {
            return
        }

        var productCardElem = quickElem.closest("product-card.product-card")
        var productHandle = productCardElem.getAttribute("handle")
        
        wus.handleProductBuyItWith(elem, productHandle, false)
    }

    function handleBigATC() {
        wus.alreadyUsedBIWProduct = false
        var elem = document.querySelector(".shopify-section--wus-biw-f .wus-biw-main");
        if (!elem) {
            return
        }

        let productHandle = wus.getProductHandle()
        wus.handleProductBuyItWith(elem, productHandle, true)
    }
    
    document.addEventListener("click", function(e) {
        if (e.target && e.target.closest(".product-card .product-card__quick-buy")) {
            handleQuickATC(e.target)
            return
        }

        if (e.target && 
            e.target.tagName.toLowerCase() === "a" &&
            e.target.closest(".shopify-section--wus-biw-f .product-card .product-card__info")) {
            handleBiwNavClick(e.target)
            return
        }

        if (e.target && 
            (e.target.tagName.toLowerCase() === "a" || e.target.tagName.toLowerCase() === "img") &&
            e.target.closest(".shopify-section--wus-biw-f .product-card .product-card__figure")) {
            handleBiwNavClick(e.target)
            return
        }
        
        if (e.target && e.target.closest(".product-info__buy-buttons buy-buttons.buy-buttons")) {
            handleBigATC()
            return
        }

        if (e.target && e.target.closest(".horizontal-product .horizontal-product__info .horizontal-product__cta")) {
            handleHorQuickATC(e.target)
            return
        }
    })
}

wus.handleProductCart

wus.formatPrice = function(price) {
    const formattedNumber = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);

    return formattedNumber
}

wus.getGenderFromProductObj = function(product) {
    let gender = ""

    const kidsArray = ["Kids", "Boys", "Girls", "Youth"]

    if (product.tags) {
        let tags = product.tags.split(", ")
        if (kidsArray.some(item => tags.includes(item))) {
            gender = "Kids"
        } else if (tags.includes("Men") && tags.includes("Women")) {
            gender = "Unisex"
        } else if (tags.includes("Men")) {
            gender = "Men"
        } else if (tags.includes("Women")) {
            gender = "Women"
        }
    }

    return gender
}

wus.getSportFromProductObj = function(product) {
    let itemRet = ""

    const sportsArray = ["football", "basketball", "tennis", "PADEL"]

    if (product.tags) {
        let tagsArr = product.tags.split(", ")
        itemRet = tagsArr.find(item => 
            sportsArray.some(otherItem => otherItem.toLowerCase() === item.toLowerCase())
        );
    }

    return itemRet
}

wus.isLifeStyleProduct = function(product) {
    if (product.tags) {
        let tagsArr = product.tags.toLowerCase().split(", ")
        if (tagsArr.includes("lifestyle")) {
            return true
        }
    }

    return false
}

wus.getVendorFromProductObj = function(product) {
    let itemRet = ""

    const vendorsArray = ["nike", "adidas"]

    if (product.vendor) {
        itemRet = vendorsArray.find(item => item.toLowerCase() === product.vendor.toLowerCase()) || null;
    }

    return itemRet
}

wus.handleProductBuyItWith = async function(biwElem, productHandle, isMainProduct) {
    if (typeof productHandle !== "string") {
        return
    }

    let viewMode = biwElem.getAttribute("data-product-vm")
    let secionId = biwElem.getAttribute("data-section-id")

    let productsRecomBIW = await wus.getProductsRecomBIW()
    let productJSON = await wus.fetchProductJSON(productHandle)

    if (!(productJSON.product && productJSON.product.product_type)) {
        return
    }

    if (isMainProduct) {
        window.wus.currentProduct = productJSON.product
    } else {
        wus.floatingBIWProduct = productJSON.product
    }
    
    let productRecoms = productsRecomBIW[productJSON.product.product_type]
    let gender = wus.getGenderFromProductObj(productJSON.product)
    let sport = wus.getSportFromProductObj(productJSON.product)
    let vendor = wus.getVendorFromProductObj(productJSON.product)
    let products = []

    var isShoesProduct = false

    if (productJSON.product.product_type && productJSON.product.product_type.toLowerCase().includes("shoes")) {
        isShoesProduct = true
    }
    
    let productDirectMatch = wus.getProductDirectMatchHandle()

    if (!Array.isArray(productRecoms)) {
        productRecoms = []
    }

    var promises = []

    if (typeof productDirectMatch === "string" && productDirectMatch.length > 0) {
        promises.push(wus.fetchProductMatch(productDirectMatch))
    }

    for (var recom of productRecoms) {
        promises.push(wus.getSuggestedProductByType(recom, gender, sport, vendor, productJSON.product))
    }

    if (Array.isArray(wus.currentMainProduts) && isMainProduct) {
        products = wus.currentMainProduts    
    } else {
        const results = await Promise.all(promises);
        products.push(...results)
    }

    products.sort((a, b) => {
        const priceA = a && a.price_max ? parseFloat(a.price_max) : Infinity;
        const priceB = b && b.price_max ? parseFloat(b.price_max) : Infinity;
      
        return priceA - priceB;
    });

    if (isShoesProduct) {
        var extraShoesProducts = ["0kfi1mvb"];

        var extraPromises = []
        var finalExtraProducts = []

        for (var extraShoesProduct of extraShoesProducts) {
            extraPromises.push(wus.fetchProductMatch(extraShoesProduct))
        }

        var extraProducts = await Promise.all(extraPromises)

        products = [...extraProducts, ...products];
    }

    let singleProdcutCardHTML = window.WUS_BIW_TEMPLATE["wus-single-product-biw-card"]

    if (viewMode === "v") {
        singleProdcutCardHTML = window.WUS_BIW_TEMPLATE["wus-single-product-biw-code"]
    }

    let allProductsHTML = ""
    
    if (!Array.isArray(products)) {
        return
    }

    if (products.filter(item => item !== null).length <= 2) {
        biwElem.classList.add("wus-biw-remove-more")
    }

    for (var suggestedProduct of products) {
        if (!suggestedProduct) {
            continue
        }

        let pHTML = singleProdcutCardHTML
        
        pHTML = pHTML.replace(new RegExp("P_IMG", 'g'), suggestedProduct.image)
        pHTML = pHTML.replace(new RegExp("P_HANDLE", 'g'), suggestedProduct.handle)
        pHTML = pHTML.replace(new RegExp("P_PID", 'g'), suggestedProduct.id)
        pHTML = pHTML.replace(new RegExp("P_TITLE", 'g'), suggestedProduct.title)
        pHTML = pHTML.replace(new RegExp("TEMP_ID", 'g'), secionId)
        pHTML = pHTML.replace(new RegExp("P_VENDOR", 'g'), suggestedProduct.vendor)

        let compareAtPrice = suggestedProduct.compare_at_price_max
        let currentPrice = suggestedProduct.price_max
        
        let compareAtPriceFloat = parseFloat(compareAtPrice)

        if (!isNaN(compareAtPriceFloat) && compareAtPriceFloat > 0) {
            pHTML = pHTML.replace(new RegExp("P_S_PRICE_STYLE", 'g'), "")
            pHTML = pHTML.replace(new RegExp("P_O_PRICE_CLASS", 'g'), "line-through")
            pHTML = pHTML.replace(new RegExp("P_S_PRICE", 'g'), wus.formatPrice(currentPrice))
            pHTML = pHTML.replace(new RegExp("P_O_PRICE", 'g'), wus.formatPrice(compareAtPrice))
        } else {
            pHTML = pHTML.replace(new RegExp("P_S_PRICE_STYLE", 'g'), "display: none;")
            pHTML = pHTML.replace(new RegExp("P_O_PRICE_CLASS", 'g'), "")
            pHTML = pHTML.replace(new RegExp("P_O_PRICE", 'g'), wus.formatPrice(currentPrice))
        }

        if (viewMode === "h") {
            if (suggestedProduct.tags && Array.isArray(suggestedProduct.tags) && suggestedProduct.tags.length > 0) {
                const isExpress = suggestedProduct.tags.map(item => item.toLowerCase()).includes("express");
                let expressDisplayValue = "none"
                if (isExpress) {
                    expressDisplayValue = "flex"
                }

                pHTML = pHTML.replace(new RegExp("EXPRESS_DISPLAY", 'g'), expressDisplayValue)   
            }
        }

        allProductsHTML += pHTML
    }

    let wusRecommendationsElem = biwElem.querySelector("wus-product-recommendations")

    if (!wusRecommendationsElem) {
        return
    }

    if (allProductsHTML === "") {
        return
    }

    if (viewMode === "v") {
        let listElem = wusRecommendationsElem.querySelector(".horizontal-product-list")
        listElem.innerHTML = allProductsHTML
    } else {
        let carouselViewHTML = window.WUS_BIW_TEMPLATE["wus-biw-carousel-code"]
        carouselViewHTML = carouselViewHTML.replace(new RegExp("TEMP_ID", 'g'), secionId)
        carouselViewHTML = carouselViewHTML.replace("PRODUCT_LIST", allProductsHTML)
        wusRecommendationsElem.innerHTML = carouselViewHTML

        var parentElement = hasParentWithClass(wusRecommendationsElem, "shopify-section--wus-biw-f")

        if (parentElement !== null) {
            parentElement.classList.remove("wus-biw-has-products")
            if (allProductsHTML !== "") {
                parentElement.classList.add("wus-biw-has-products")
            }
            wus.handleProductBIWFloating(parentElement)
        }
    }

    biwElem.style["display"] = "block"
    wus.handleLoadMoreBIW(biwElem)
}

wus.handleLoadMoreBIW = function(biwElem) {
    let loadMoreElem = biwElem.querySelector(".load-more-biw")
    if (!loadMoreElem) {
        return
    }

    loadMoreElem.onclick = function() {
        biwElem.classList.toggle('biw-show-all')
    }
}

wus.handleChatSupportPage = function() {
    if (!(window.location.href.indexOf("pages/chat-support") > -1)) {
        return
    }

    if (!window.zE) {
        setTimeout(function() {
            wus.handleChatSupportPage()
        }, 50)
        return
    }

    let launcherElem = document.getElementById("launcher");

    if (!launcherElem) {
        setTimeout(function() {
            wus.handleChatSupportPage()
        }, 50)

        return
    }

    window.zE('messenger', 'open');
}

wus.closeMobileMenu = function() {
    if (!wus.isMobileScreen()) {
        return
    }

    var sideMenuElem = document.querySelector("#header-sidebar-menu")
    if (!sideMenuElem) {
        return
    }

    sideMenuElem.shadowRoot.querySelector("[part='overlay']").click()
}

wus.sendEventGA = function(name, category, label, value) {
    if (typeof gtag !== "function") {
        return
    }

    try {
        gtag('event', name, {
            'event_category': category || "",
            'event_label': label || "",
            'value': value || ""
        });
    } catch(e) {
        console.error(e)
    }
}

wus.handleLangButton = function() {
    var elem = document.querySelector("#wus-lang-selector-mobile");
    if (elem) {
        elem.addEventListener("click", function(e) {
            e.preventDefault()
            let mobileElemButton = document.querySelector("header button[aria-controls*='popover-localization-form-locale']")
            if (mobileElemButton) {
                wus.closeMobileMenu()
                mobileElemButton.click()
            }
        })
    }
}

wus.handleMenuLangButton = function() {
    let elem = document.querySelector("header button[aria-controls*='popover-localization-form-locale']")
    if (elem) {
        elem.addEventListener("click", function(e) {
            wus.closeMobileMenu();
        })
    }
}

wus.handleLanguage = function() {
    wus.handleLangButton();
    wus.handleMenuLangButton();
    function redirectLang(langCode) {
        var supportedLangs = ["ar"]
        const urlObject = new URL(window.location.href);
        var currentPathname = urlObject.pathname

        for (var i = 0; i < supportedLangs.length; i++) {
            var lang = supportedLangs[i]
            var singleSlash = "/" + lang
            var multipleSlash = singleSlash + "/"
            if (currentPathname === singleSlash || currentPathname.startsWith(multipleSlash)) {
                currentPathname = currentPathname.replace("/" + lang, "")
                break;
            }
        }

        if (langCode !== "en") {
            window.location.pathname = '/' + langCode + currentPathname;
        } else {
            window.location.pathname = currentPathname
        }
    }

    function checkLangOnStart() {
        let htmlElem = document.documentElement
        let currentLang = htmlElem.getAttribute("lang")

        let savedLang = localStorage.getItem("WUS_LAST_USED_LANG")

        if (typeof savedLang === "string" && savedLang.length > 0) {
            if (savedLang !== currentLang) {
                redirectLang(savedLang)
            }
        }
        
        
        let langButtons = document.querySelectorAll(".popover-listbox__option[name='locale_code']")

        for (var i = 0; i < langButtons.length; i++) {
            var langButton = langButtons[i]
            langButton.addEventListener("click", function() {
                let value = this.getAttribute("value")
                if (typeof value === "string") {
                    localStorage.setItem("WUS_LAST_USED_LANG", value)
                }
            })
        }
    }

    checkLangOnStart()
    
    if (wus.isMobileScreen()) {
        let mobileElemButton = document.querySelector(".navigation-drawer .panel-footer__localization-wrapper button[aria-controls*='popover-localization-form-locale']")
        if (mobileElemButton) {
            mobileElemButton.addEventListener("click", function() {
                wus.closeMobileMenu()
            })
        }    
    }
}

wus.handleStockChecked = function() {
    try {
        var elems = document.querySelectorAll('input[name="filter.v.availability"]');
        
        if (!elems) {
            return
        }

        if (elems.length === 0) {
            return
        }

        for (var i = 0; i < elems.length; i++) {
            var elem = elems[i];
            elem.checked = true
        }
    } catch(e) {
        console.error(e)
    }
    
}

wus.handleDisableVendorLink = function() {
    var elems = document.querySelectorAll('.wus-vendor-link');
        
    if (!elems) {
        return
    }

    if (elems.length === 0) {
        return
    }

    for (var i = 0; i < elems.length; i++) {
        var elem = elems[i];
        elem.addEventListener('click', function(event) {
            if (this.hasAttribute("data-link-updated")) {
                return;
            }

            event.preventDefault();
        });
    }
}

wus.showNewsletterButton = function() {
    var elem = document.getElementById("wus-newsletter-button")
    if (!elem) {
        return
    }

    setTimeout(function() {
        elem.classList.add("show");
    }, 1500)
}

wus.handleNewsletterButton = function() {
    var elem = document.getElementById("wus-newsletter-button")
    var nlElem = document.getElementById("newsletter-drawer")
    
    if (!elem) {
        return
    }

    if (!nlElem) {
        return
    }

    elem.onclick = function() {
        if (nlElem.classList.contains("show-close-cursor")) {
            return;
        }
        window.showNewsLetterWUS()
    }
}

wus.openNewLetterOnLink = function() {
    let currentLink = window.location.href;

    if (!currentLink.includes("#osb")) {
        return;
    }

    var nlElem = document.getElementById("newsletter-drawer");

    if (!nlElem) {
        setTimeout(function() {
            wus.openNewLetterOnLink();
        }, 100);
        return;
    }

    if (nlElem.classList.contains("show-close-cursor")) {
        return;
    }
    window.showNewsLetterWUS()
}

wus.handleEndlessCarousels = function() {
    var elems = document.querySelectorAll(".wus-endless-carousel-wrapper");
    for (var elem of elems) {
        wus.handleEndlessCarousel(elem);
    }
}

// wus.handleEndlessCarousel = function(elem) {
//     let isResuming = false;
//     let isResumingTimeout = null;
//     var isDraggable = elem.classList.contains("wus-endless-carousel-draggable-true");

//     function enableCarouselDrag(carousel) {
//         let parent = carousel.closest(".wus-endless-carousel-container");
//         let items = carousel.querySelectorAll(".wus-endless-carousel-item");
//         let firstMobileItem = carousel.querySelectorAll(".wus-endless-carousel-item-mobile")[0];
//         let firstDesktopItem = carousel.querySelectorAll(".wus-endless-carousel-item-desktop")[0];

//         let itemsLength = items.length / 4;
        
//         let firstElem = firstDesktopItem;

//         if (wus.isMobileScreen()) {
//             firstElem = firstMobileItem;
//         }

//         let itemWidth = carousel.clientWidth / itemsLength;

//         if (firstElem) {
//             itemWidth = firstElem.clientWidth;
//         }

//         let itemsPerScreen = window.innerWidth / itemWidth;
//         let carouselWidth = carousel.clientWidth / 2;
        
//         let maxTranslate = carouselWidth - (itemsPerScreen * itemWidth);
//         console.log(itemsLength, itemWidth, maxTranslate);
//         const isFromLeft = carousel.classList.contains("from-left");

//         if (isFromLeft) {
//             maxTranslate = -maxTranslate;
//         }

//         let isDown = false;
//         let startX;
//         let currentTransform = 0;
    
//         function getTranslateX() {
//           const style = window.getComputedStyle(carousel).transform;
//           if (style === 'none') return 0;
//           const matrix = new DOMMatrix(style);
//           let translate = matrix.m41;

//           return translate;
//         }
    
//         function pauseAnimation() {
//           currentTransform = getTranslateX();
//           console.log("currentTransform", currentTransform);
//           carousel.style.transform = `translateX(${currentTransform}px)`;
//           carousel.style.animation = 'none';
//         }
    
//         function startDrag(x) {
//           isDown = true;
//           startX = x;
//           clearTimeout(isResumingTimeout);
//           pauseAnimation();
//           carousel.classList.add('dragging');
//         }
    
//         function moveDrag(x) {
//           if (!isDown) return;
//           clearTimeout(isResumingTimeout);
//           const walk = x - startX;
//           let newTransform = currentTransform + walk;
//           if (isFromLeft) {
//             if (newTransform < maxTranslate) {
//               newTransform = maxTranslate;
//             }
//             if (newTransform > 0) {
//                 newTransform = 0;
//             }
//           } else {
//             if (newTransform > maxTranslate) {
//               newTransform = maxTranslate;
//             }
//             if (newTransform < 0) {
//                 newTransform = 0;
//             }
//           }
//           carousel.style.transform = `translateX(${newTransform}px)`;
//         }
    
//         function endDrag(x) {
//           if (!isDown) return;
//           isDown = false;
//           const walk = x - startX;
//           currentTransform += walk;
//           resumAnimation();
//         }

//         function resumAnimation() {
//             if (isResuming) {
//                 return;
//             }

//             isResumingTimeout = setTimeout(() => {
//                 isResuming = true;

//                 carousel.style.transition = "transform 0.2s ease-in-out";
//                 carousel.style.transform = `translateX(0px)`;

//                 setTimeout(() => {
//                     carousel.classList.remove('dragging');
//                     carousel.style.removeProperty("transform");
//                     carousel.style.removeProperty("animation");
//                     carousel.style.removeProperty("transition");
//                     isResuming = false;
//                 }, 200);
//             }, 2000);
//         }
    
//         carousel.addEventListener('mousedown', e => startDrag(e.pageX));
//         carousel.addEventListener('mousemove', e => moveDrag(e.pageX));
//         carousel.addEventListener('mouseup', e => endDrag(e.pageX));
//         carousel.addEventListener('mouseleave', e => endDrag(e.pageX));
    
//         carousel.addEventListener('touchstart', e => startDrag(e.touches[0].clientX), { passive: true });
//         carousel.addEventListener('touchmove', e => moveDrag(e.touches[0].clientX), { passive: true });
//         carousel.addEventListener('touchend', e => endDrag(e.changedTouches[0].clientX));

//         window.addEventListener("scroll", function() {
//             resumAnimation();
//         });
//     }

//     if (isDraggable) {
//         enableCarouselDrag(elem);
//     }
// }

wus.handleEndlessCarousel = function(elem) {
    let isResuming = false;
    let resumeTimeout = null;
    const isDraggable = elem.classList.contains("wus-endless-carousel-draggable-true");
  
    function enableCarouselDrag(carousel) {
        const parent = carousel.closest(".wus-endless-carousel-container");
        const isFromLeft = carousel.classList.contains("from-left");
    
        let currentTransform = 0;
        let isScrolling = false;
    
        function getTranslateX() {
            const style = window.getComputedStyle(carousel).transform;
            if (style === 'none') return 0;
            const matrix = new DOMMatrix(style);
            return matrix.m41;
        }
    
        function pauseAnimationToScroll() {
            if (carousel.classList.contains("scrolling")) {
                return;
            }

            carousel.classList.add("scrolling");
            currentTransform = getTranslateX();
            carousel.style.animation = 'none';
            // carousel.style.transform = `translateX(${currentTransform}px)`;
            carousel.style.transform = `translateX(0px)`;
    
            // enable scroll
            parent.style.overflowX = 'auto';
            // parent.scrollLeft = isFromLeft
            //   ? parent.scrollWidth - parent.clientWidth + currentTransform
            //   : -currentTransform;

            parent.scrollLeft = Math.abs(currentTransform);
        }
    
        function resumeAnimationFromScroll() {
            if (isResuming) return;
            isResuming = true;
    
            const delay = 5_000;
    
            resumeTimeout = setTimeout(() => {
                parent.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                });

                parent.style.overflowX = 'hidden';
                carousel.style.transition = 'transform 0.4s ease-out';
                carousel.style.transform = 'translateX(0px)';

                setTimeout(() => {
                    carousel.style.removeProperty('transform');
                    carousel.style.removeProperty('animation');
                    carousel.style.removeProperty('transition');
                    isResuming = false;
                    carousel.classList.remove("scrolling");
                }, 400);
            }, delay);
        }
    
        function cancelResumeTimer() {
            clearTimeout(resumeTimeout);
            resumeTimeout = null;
            isResuming = false;
        }
    
        // Track when user interacts
        function startScrollMode(x) {
            pauseAnimationToScroll();
            cancelResumeTimer();
        }
    
        // Use native scroll events to detect user activity
        parent.addEventListener('scroll', () => {
            cancelResumeTimer();
            resumeAnimationFromScroll();
        });
    
        // Mouse
        carousel.addEventListener('mousedown', e => startScrollMode(e.pageX));
    
        // Touch
        carousel.addEventListener('touchstart', e => startScrollMode(e.touches[0].clientX), { passive: true });
    }
  
    if (isDraggable) {
      enableCarouselDrag(elem);
    }
};
  
wus.handleAnivLogo = function() {
    var elem = document.getElementById("wus-aniv-logo-container");
    if (!elem) {
        return;
    }

    function checkAnivLogo() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
      
        const scrollPercent = (scrollTop + windowHeight) / documentHeight;
      
        if (scrollPercent > 0.2) {
          if (!elem.classList.contains("show-aniv-logo")) {
            elem.classList.add("show-aniv-logo");
          }
        } else {
          if (elem.classList.contains("show-aniv-logo")) {
            elem.classList.remove("show-aniv-logo");
          }
        }
    }

    window.addEventListener("scroll", () => {
        checkAnivLogo();
    });

    setTimeout(() => {  
        elem.classList.add("add-transition");
        setTimeout(() => {
            checkAnivLogo();
        }, 100);
    }, 600);

    
}

wus.handlePageProtected = function() {
    var elem = document.querySelector(".wus-page-protected");
    
    if (!elem) {
        return;
    }

    let passwordsText = document.querySelector(".wus-page-protected-passwords");
    if (!passwordsText) {
        return;
    }

    let passwords = passwordsText.textContent;
    if (!passwords) {
        return;
    }

    let passwordsArray = passwords.split("\n");
    if (!passwordsArray) {
        return;
    }

    let customerPassword = window.prompt("Enter the password");
    
    if (customerPassword === null) {
        window.location.reload();
        return;
    }

    if (passwordsArray.includes(customerPassword)) {
        elem.classList.remove("wus-page-protected");
    } else {
        window.location.reload();
    }
}

wus.handleVendorLinks = function() {
    let targetBrandNameElems = document.querySelectorAll(".wus-vendor-link");
    for (let targetBrandNameElem of targetBrandNameElems) {
        wus.handleVendorLink(targetBrandNameElem);
    }
}

wus.handleVendorLink = function(targetBrandNameElem) {
    let selectorElem = document.querySelector(".mega-menu__nav a[href*='/pages/adidas']");

    if (!selectorElem) {
        return;
    }

    // let targetBrandNameElem = document.querySelector(".product-info .product-info__vendor");

    if (!targetBrandNameElem) {
        return;
    }

    let targetBrandName = targetBrandNameElem.textContent.trim();

    let selectedBrandLink = null;

    let listElem = selectorElem.closest(".mega-menu__nav");
    let listItems = listElem.querySelectorAll("li");
    for (let item of listItems) {
        let brandLink = item.querySelector("a").getAttribute("href");
        let brandName = item.querySelector("span").textContent.trim();

        if (brandName.toLowerCase() === targetBrandName.toLowerCase()) {
            selectedBrandLink = brandLink;
            break;
        }
    }

    if (!selectedBrandLink) {
        return;
    }

    // let targetBrandLinkElemAnchor = targetBrandNameElem.querySelector("a");

    if (targetBrandNameElem) {
        targetBrandNameElem.setAttribute("href", selectedBrandLink);
        targetBrandNameElem.setAttribute("data-link-updated", "true");
    }
}

wus.runCommons = function() {
    this.handleAnnouncementBarLinks()
    wus.handleAccesoriesLink()
    wus.handleChatSupportPage()
    wus.handleProductsBIW()
    wus.handleLanguage()
    wus.handleStockChecked()
    wus.handleNewsletterButton()
    wus.fireScriptLazy()
    wus.handleFun()
    wus.handleLoyaltyButton()
    wus.handleWishList()
    wus.handleJQ()
    wus.handleLifestyleLink()
    wus.handleSearchPlaceholder()
    wus.handleLuckyHour();

    // wus.handleCheckoutFixTemp()

    wus.handleProductCounters();
    wus.handleEndlessCarousels();
    wus.handleAnivLogo();
    wus.handleRefundForms();

    wus.handlePageProtected();

    setTimeout(() => {
        wus.handleProductCardInstallmentButton();
    }, 1000);

    setTimeout(() => {
        wus.openNewLetterOnLink();
    }, 100);

    setTimeout(() => {
        wus.handleLoyaltyArrow();
    }, 100);

    setTimeout(() => {
        wus.handleVendorLinks();
    }, 1000);

    setTimeout(() => {
        wus.handleDisableVendorLink();
    }, 2000);

    setTimeout(() => {
        wus.startHandleOptionsProductCards();
    }, 1000);

    wus.setMainProductTemplateId();

    setTimeout(() => {
        wus.handlePaginationUrls();
    }, 1000);

    setTimeout(() => {
        wus.handleCollectionTabs();
    }, 100);
}

wus.handleFun = function() {
    wus.handleFunBoms()
}

wus.handleFunBoms = function() {
    var elems = document.querySelectorAll(".wus-fun-bom-container");
    for (var elem of elems) {
        wus.handleFunBom(elem);
        wus.handleFunBomScroll(elem);
    }

    document.addEventListener("scroll", function() {
        for (var elem of elems) {
            wus.handleFunBomScroll(elem);
        }
    });

    window.addEventListener('wheel', function(event) {
        for (var elem of elems) {
            wus.handleFunBomWheel(elem, event);
        }
    });

    window.addEventListener('keydown', function(event) {
        for (var elem of elems) {
            wus.handleFunBomKeydown(elem, event);
        }
    });

    document.addEventListener('touchstart', (event) => {
        startY = event.touches[0].clientY;
    });

    document.addEventListener('touchmove', (event) => {
        for (var elem of elems) {
            wus.handleFunBomTouchmove(elem, event);
        }
    });
}

wus.isRTL = function() {
    var isRTL = false;
    
    if (Shopify && Shopify.locale === "ar") {
        isRTL = true;
    }

    return isRTL;
}

wus.handleFunBom = function(elem) {
    var type = elem.getAttribute("data-type");
    
    if (type === "wus-fun-bom-type-trio") {
        wus.handleFunBomTrio(elem);
        return;
    }

    if (type === "wus-fun-bom-type-slideout") {
        wus.handleFunBomSlideout(elem);
        return;
    }

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleFunVershow(elem);        
        return;
    }
}

wus.handleFunVershow = function(elem) {
    const headerElem = document.querySelector("header");
    const parent = elem.closest(".shopify-section--wus-fun-stuff");
    const mainElem = elem.querySelector(".wus-fun-vershow-main")
    const headerHeight = headerElem.clientHeight;

    const elemHeight = window.innerHeight - headerHeight;
    const hrefElem = elem.querySelector(".wus-fun-bom-link");
    const imagesShow = elem.querySelectorAll(".wus-fun-vershow-img");

    //const allContainerHeight = elemHeight * (imagesShow.length + (imagesShow.length / 2));
    const allContainerHeight = elemHeight * (imagesShow.length);

    elem.style["height"] = allContainerHeight + "px";
    
    hrefElem.style["height"] = elemHeight + "px";
    hrefElem.style["position"] = "sticky";
    hrefElem.style["top"] = headerHeight + "px";

    setTimeout(() => {
        elem.classList.add("ready");
    }, 300);

    wus.checkVershowFirstElem(elem);
}

wus.handleFunBomSlideout = function(elem) {
    var parent = elem.closest(".shopify-section--wus-fun-stuff");
    var imageElem = elem.querySelector(".wus-fun-bom-img-slideout");
    var textElem = elem.querySelector(".wus-fun-bom-text-container-slideout")

    var imageWidth = imageElem.clientWidth;
    var imageHeight = imageElem.clientHeight;

    let rect = elem.getBoundingClientRect();

    let imageLeftPercentage = 0.5;
    let imageTopPercentage = 0.5;

    let imageLeftPosition = rect.width * imageLeftPercentage;
    let imageTopPosition = rect.height * imageTopPercentage;

    imageElem.style["left"] = (imageLeftPosition) + "px";
    imageElem.style["top"] = (imageTopPosition) + "px";

    imageElem.style["margin-left"] = -(imageWidth / 2) + "px";
    imageElem.style["margin-top"] = -(imageHeight / 2) + "px";

    setTimeout(() => {
        elem.classList.add("ready");
    }, 300);
}

wus.handleFunBomTrio = function(elem) {
    var parent = elem.closest(".shopify-section--wus-fun-stuff")
    var targetImageOne = parent.querySelector(".wus-fun-bom-img-1")

    var imageOneWidth = targetImageOne.clientWidth
    let rect = elem.getBoundingClientRect();

    var targetImageOneLeft = 0.55
    var targetImageOneTop = 0.40

    if (wus.isRTL()) {
        targetImageOneLeft = 0.17
    }

    if (innerWidth > 1500) {
        targetImageOneLeft = 0.60

        if (wus.isRTL()) {
            targetImageOneLeft = 0.20
        }
    }

    if (innerWidth < 1000) {
        var leftPercentage = (rect.width / 2 - imageOneWidth / 2) / rect.width
        targetImageOneLeft = leftPercentage
        targetImageOneTop = 0.47
    }

    var targetImageTwoLeft = targetImageOneLeft - 0.11
    var targetImageTwoTop = targetImageOneTop + 0.08
    var targetImageThreeLeft = targetImageOneLeft + 0.11
    var targetImageThreeTop = targetImageOneTop - 0.08
    
    var targetImageTwo = parent.querySelector(".wus-fun-bom-img-2")
    var targetImageTree = parent.querySelector(".wus-fun-bom-img-3")
    
    //var isRTL = wus.isRTL()

    var isRTL = false
    
    targetImageOne.style[isRTL ? "right" : "left"] = (rect.width * targetImageOneLeft) + "px" 
    targetImageOne.style["top"] = (rect.height * targetImageOneTop) + "px" 

    targetImageTwo.style[isRTL ? "right" : "left"] = (rect.width * targetImageTwoLeft) + "px" 
    targetImageTwo.style["top"] = (rect.height * targetImageTwoTop) + "px" 

    targetImageTree.style[isRTL ? "right" : "left"] = (rect.width * targetImageThreeLeft) + "px" 
    targetImageTree.style["top"] = (rect.height * targetImageThreeTop) + "px" 

    setTimeout(() => {
        elem.classList.add("ready")
    }, 300);
}

wus.mapValues = function(value, in_min, in_max, out_min, out_max) {
    return ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}

wus.handleFunBomScroll = function(elem) {
    var type = elem.getAttribute("data-type");
    
    if (type === "wus-fun-bom-type-trio") {
        wus.handleFunBomTrioScroll(elem);
        return;
    }

    if (type === "wus-fun-bom-type-slideout") {
        wus.handleFunBomSlideoutScroll(elem);
        return;
    }

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleFunVershowScroll(elem);
        return;
    }
}

wus.handleFunBomWheel = function(elem, event) {
    var type = elem.getAttribute("data-type");

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleFunVershowWheel(elem, event);
        return;
    }
}

wus.handleFunBomTouchmove = function(elem, event) {
    var type = elem.getAttribute("data-type");

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleVershowTouchMove(elem, event);
        return;
    }
}

wus.handleVershowTouchMove = function(elem, event) {
    const currentY = event.touches[0].clientY;
    const deltaY = startY - currentY;

    if (!elem.classList.contains("vershow-active")) {
        return
    }

    if (deltaY < 0) {
        wus.handleFunVershowUpDown(elem, "u")
        return;
    }
    
    if (deltaY > 0) {
        wus.handleFunVershowUpDown(elem, "d")
        return;
    }

    startY = currentY;
}

wus.handleFunBomKeydown = function(elem, event) {
    var type = elem.getAttribute("data-type");

    if (type === "wus-fun-bom-type-vershow") {
        wus.handleFunVershowKeydown(elem, event);
        return;
    }
}

wus.handleFunVershowWheel = function(elem, event) {
    if (!elem.classList.contains("vershow-active")) {
        return
    }

    if (event.deltaY < 0) {
        wus.handleFunVershowUpDown(elem, "u")
        return;
    }
    
    if (event.deltaY > 0) {
        wus.handleFunVershowUpDown(elem, "d")
        return;
    }
}

wus.vershowMoving = false;

wus.handleFunVershowKeydown = function(elem, event) {
    if (!elem.classList.contains("vershow-active")) {
        return;
    }

    if (event.key === "ArrowUp") {
        wus.handleFunVershowUpDown(elem, "u")
        return;
    }

    if (event.key === "ArrowDown") {
        wus.handleFunVershowUpDown(elem, "d")
        return;
    }
}

wus.checkVershowFirstElem = function(elem) {
    let activeElem = elem.querySelector('.wus-fun-vershow-img[data-slide="main"]');
    
    if (activeElem) {
        return
    }

    let allImages = elem.querySelectorAll('.wus-fun-vershow-img');

    let newActiveElem = allImages.length > 0 ? allImages[0] : null;

    if (!newActiveElem) {
        return;
    }

    //wus.setFunVershowActive(newActiveElem, allImages, "d", elem);
    wus.setFunVershowActiveByIndex(elem, 1);
}

wus.isVershowChagning = false

wus.setFunVershowActiveByIndex = function(elem, newIndex) {
    if (wus.isVershowChagning) {
        return
    }

    wus.isVershowChagning = true;
    let allImages = elem.querySelectorAll('.wus-fun-vershow-img');
    let imageShows = elem.querySelectorAll(".wus-fun-vershow-img");

    var currentIndex = -1;

    for (var i = 0; i < imageShows.length; i++) {
        var imageShow = imageShows[i];
        if (imageShow.getAttribute("data-slide") === "main") {
            currentIndex = i;
            break;
        }
    }
    
    currentIndex = currentIndex + 1;

    if (newIndex === currentIndex) {
        wus.isVershowChagning = false;
        return;
    }

    const direction = newIndex > currentIndex ? "d" : "u";

    let newActiveElem = allImages[newIndex - 1];

    if (!newActiveElem) {
        wus.isVershowChagning = false;
        return;
    }

    wus.setFunVershowActive(newActiveElem, imageShows, direction, elem);
    wus.isVershowChagning = false;
}

wus.handleFunVershowUpDown = function(elem, direction) {
    if (wus.vershowMoving) {
        return;
    }

    wus.vershowMoving = true;

    setTimeout(function() {
        wus.vershowMoving = false;
    }, 2000);

    let imageShows = elem.querySelectorAll(".wus-fun-vershow-img");
    let activeElem = elem.querySelector('.wus-fun-vershow-img[data-slide="main"]');

    if (!activeElem) {
        return
    }

    let prevActive = activeElem.previousElementSibling;
    let afterActive = activeElem.nextElementSibling;
    let imageShowLength = imageShows.length;
    
    let newActiveElem = direction === "d" ? afterActive : prevActive;

    if (!newActiveElem) {
        //wus.enableScroll();
        wus.disableFunVershow(elem, direction);
        return;
    }

    wus.setFunVershowActive(newActiveElem, imageShows, direction, elem);
}

wus.setFunVershowActive = function(newActiveElem, imageShows, direction, elem) {
    if (!newActiveElem) {
        return;
    }

    let prevActive = newActiveElem.previousElementSibling;
    let afterActive = newActiveElem.nextElementSibling;

    newActiveElem.setAttribute("data-slide", "main")

    let textIndex = newActiveElem.getAttribute("data-text");
    let url = newActiveElem.getAttribute("data-url");

    //console.log(textIndex);
    //console.log(url);
    
    let hrefElem = elem.querySelector(".wus-fun-bom-link")
    hrefElem.setAttribute("href", url);

    let targetTextElem = elem.querySelector(`.wus-fun-vershow-text-active[data-text="${textIndex}"]`);

    let textElems = elem.querySelectorAll(".wus-fun-vershow-text-active");

    for (const textElem of textElems) {
        textElem.classList.remove("wus-fun-vershow-text-show");
    }

    targetTextElem.classList.add("wus-fun-vershow-text-show");

    setTimeout(function() {
        //targetTextElem.classList.add("wus-fun-vershow-text-show");
    }, 100)
    

    if (direction === "u") {
        while (afterActive) {
            if (afterActive.getAttribute("data-slide") === "main") {
                afterActive.setAttribute("data-slide", "before");
            } else if (afterActive.getAttribute("data-slide") === "nono") {
                afterActive.setAttribute("data-slide", "sub");
            }

            afterActive = afterActive.nextElementSibling
        }

        if (prevActive) {
            prevActive.setAttribute("data-slide", "sub")
        }
    } else {
        while (prevActive) {
            if (prevActive.getAttribute("data-slide") === "main") {
                prevActive.setAttribute("data-slide", "sub");
            } else if (prevActive.getAttribute("data-slide") === "sub") {
                prevActive.setAttribute("data-slide", "nono");
            }

            prevActive = prevActive.previousElementSibling
        }

        if (afterActive) {
            afterActive.setAttribute("data-slide", "before")
        }
    }
}

wus.handleFunBomSlideoutScroll = function(elem) {
    let rect = elem.getBoundingClientRect();
    var parent = elem.closest(".shopify-section--wus-fun-stuff")
    let headerHeight = document.querySelector("header").clientHeight
    const actualScrollFromBottom = (rect.top) - (window.innerHeight)
    var imageElem = elem.querySelector(".wus-fun-bom-img-slideout");
    var textElem = elem.querySelector(".wus-fun-bom-text-container-slideout")

    if (actualScrollFromBottom > 0) {
        return
    }

    const scrollValueInsideDiv = actualScrollFromBottom * -1;
    const scrollInsidePercentage = (scrollValueInsideDiv / (rect.height + headerHeight)) * 100

    let minActionPercentage = 50;
    let maxActionPercentage = 100;

    if (window.innerWidth < 999) {
        minActionPercentage = 70;
        maxActionPercentage = 110;
    }

    let isRTL = false;

    if (scrollInsidePercentage >= minActionPercentage && scrollInsidePercentage <= maxActionPercentage) {
        let activePercentage = wus.mapValues(scrollInsidePercentage, minActionPercentage, maxActionPercentage, 0, 100);
        let distancePercX = -0.5;
        let distancePercY = 0.1;
        let targetScale = 0.9;

        if (window.innerWidth < 999) {
            distancePercX = -0;
            distancePercY = 0.4;
            targetScale = 0.9;
        }

        if (window.innerWidth < 699) {
            distancePercX = -0;
            distancePercY = 0.50;
            targetScale = 0.95;
        }
        
        const imageLeft = parseInt(imageElem.style[isRTL ? "right" : "left"]);
        const imageTop = parseInt(imageElem.style["top"]);
        const travelDistanceX = imageLeft * distancePercX;
        const travelDistanceY = imageTop * distancePercY;
        
        const percDec = activePercentage / 100;

        const translateX = travelDistanceX * percDec;
        const translateY = travelDistanceY * percDec;

        const imageScale = wus.mapValues(percDec, 0, 1, 1, targetScale);
        const textScale = wus.mapValues(percDec, 0, 1, 0, 1);
        const textOpacity = wus.mapValues(percDec, 0, 1, 0, 1);

        imageElem.style.transform = `translate(${translateX}px, ${translateY}px) scale(${imageScale})`;
        textElem.style.transform = `scale(${textScale})`;
        textElem.style.opacity = textOpacity;
    }
}

wus.handleFunBomTrioScroll = function(elem) {
    let rect = elem.getBoundingClientRect();
    var parent = elem.closest(".shopify-section--wus-fun-stuff")
    let headerHeight = document.querySelector("header").clientHeight
    const actualScrollFromBottom = (rect.top) - (window.innerHeight)

    var targetImageOne = parent.querySelector(".wus-fun-bom-img-1")
    var targetImageTwo = parent.querySelector(".wus-fun-bom-img-2")
    var targetImageThree = parent.querySelector(".wus-fun-bom-img-3")

    if (actualScrollFromBottom > 0) {
        return
    }

    const scrollValueInsideDiv = actualScrollFromBottom * -1;
    const scrollInsidePercentage = (scrollValueInsideDiv / (rect.height + headerHeight)) * 100

    const minActionPercentage = 60;
    const maxActionPercentage = 180;

    //var isRTL = wus.isRTL()
    var isRTL = false;

    if (scrollInsidePercentage >= minActionPercentage && scrollInsidePercentage <= maxActionPercentage) {
        let activePercentage = wus.mapValues(scrollInsidePercentage, minActionPercentage, maxActionPercentage, 0, 100);

        const imageOneLeft = parseInt(targetImageOne.style[isRTL ? "right" : "left"]);
        const imageOneTop = parseInt(targetImageOne.style["top"]);
        const imageTwoLeft = parseInt(targetImageTwo.style[isRTL ? "right" : "left"]);
        const imageTwoTop = parseInt(targetImageTwo.style["top"]);
        const imageThreeLeft = parseInt(targetImageThree.style[isRTL ? "right" : "left"]);
        const imageThreeTop = parseInt(targetImageThree.style["top"]);

        const overshootFactorTwo = 2.5;
        const overshootFactorTree = 2.5;

        const directionTwoX = imageOneLeft - imageTwoLeft;
        const directionTwoY = imageOneTop - imageTwoTop;
        const directionThreeX = imageOneLeft - imageThreeLeft;
        const directionThreeY = imageOneTop - imageThreeTop;

        const futureTwoX = imageTwoLeft + directionTwoX * overshootFactorTwo;
        const futureTwoY = imageTwoTop + directionTwoY * overshootFactorTwo;
        const futureThreeX = imageThreeLeft + directionThreeX * overshootFactorTree;
        const futureThreeY = imageThreeTop + directionThreeY * overshootFactorTree;

        const distanceTwoX = futureTwoX - imageTwoLeft
        const distanceTwoY = futureTwoY - imageTwoTop
        const distanceThreeX = futureThreeX - imageThreeLeft
        const distanceThreeY = futureThreeY - imageThreeTop

        const translateTwoX = distanceTwoX * (activePercentage / 100);
        const translateTwoY = distanceTwoY * (activePercentage / 100);
        const translateThreeX = distanceThreeX * (activePercentage / 100);
        const translateThreeY = distanceThreeY * (activePercentage / 100);

        targetImageTwo.style.transform = `translate(${translateTwoX}px, ${translateTwoY}px) rotate(15deg)`;
        targetImageThree.style.transform = `translate(${translateThreeX}px, ${translateThreeY}px) rotate(15deg)`;
    }
}

wus.disableVerShowScroll = false;
wus.prevVershowIndex = -1;
wus.currentVershowIndex = -1;

wus.handleFunVershowScroll2 = function(elem) {
    const imagesShow = elem.querySelectorAll(".wus-fun-vershow-img");
    const number = imagesShow.length;
    
    const calculateSegments = () => {
        const rect = elem.getBoundingClientRect();
        const divTop = window.scrollY + rect.top;
        const divHeight = rect.height;
        const segmentHeight = divHeight / number;
  
        return Array.from({ length: number }, (_, i) => ({
            start: divTop + i * segmentHeight,
            end: divTop + (i + 1) * segmentHeight,
            index: i + 1,
        }));
    };

    const checkScrollPosition = () => {
        const rect = elem.getBoundingClientRect();
        const elemTop = window.scrollY + rect.top;
        const elemBottom = elemTop + rect.height;

        const scrollTop = window.scrollY;

        if (scrollTop + window.innerHeight < elemTop) {
            return "before";
        } else if (scrollTop > elemBottom) {
            return "after";
        } else {
            return "inside";
        }
    };

    const scrollStatus = checkScrollPosition();

    const scrollPos = window.scrollY + window.innerHeight / 2;
    const segments = calculateSegments();

    if (scrollStatus === "before") {
        wus.setFunVershowActiveByIndex(elem, 1);
    } else if (scrollStatus === "after") {
        wus.setFunVershowActiveByIndex(elem, number);
    } else {
        segments.forEach(segment => {
            if (scrollPos >= segment.start && scrollPos < segment.end) {
                wus.setFunVershowActiveByIndex(elem, segment.index);
            }
        });
    }
}

wus.handleFunVershowScroll = function(elem) {
    wus.handleFunVershowScroll2(elem);
    return;
    if (wus.disableVerShowScroll) {
        return;
    }

    let rect = elem.getBoundingClientRect();
    var parent = elem.closest(".shopify-section--wus-fun-stuff")
    let headerHeight = document.querySelector("header").clientHeight

    let currentDivTop = rect.top - headerHeight;
    
    console.log(currentDivTop, rect.height / 2);

    if (currentDivTop <= 50 && currentDivTop > -rect.height) {
        //wus.disableVerShowScroll = true;
        //wus.handleFunVershowInside(elem);
    }
}

wus.disableFunVershow = function(elem, direction) {
    let rect = elem.getBoundingClientRect();
    let headerHeight = document.querySelector("header").clientHeight;
    let scrollPosition = (window.scrollY + rect.top - headerHeight) + rect.height;
    
    if (direction === "u") {
        scrollPosition = window.scrollY - rect.height;
    }

    wus.disableVerShowScroll = true;

    window.scrollTo({ top: scrollPosition, behavior: "smooth" });

    elem.classList.remove("vershow-active");

    setTimeout(function() {
        wus.disableVerShowScroll = false;
        wus.enableScroll();
    }, 1000)
}

wus.handleFunVershowInside = function(elem) {
    if (elem.classList.contains("vershow-active")) {
        //return;
    }

    wus.disableScroll();

    let rect = elem.getBoundingClientRect();
    var parent = elem.closest(".shopify-section--wus-fun-stuff");
    let headerHeight = document.querySelector("header").clientHeight;
    const scrollPosition = window.scrollY + rect.top - headerHeight;
    
    window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    setTimeout(function() {
        elem.classList.add("vershow-active");
    }, 1000);
}

wus.disableScroll = function() {
    window.addEventListener('touchstart', wus.preventDefault, { passive: false });
    window.addEventListener('wheel', wus.preventDefault, { passive: false });
    window.addEventListener('keydown', wus.preventArrowKeys, { passive: false });
    if (wus.isMobileScreen()) {
        document.body.style["overflow"] = "hidden"
    }
}

wus.enableScroll = function() {
    window.removeEventListener('touchstart', wus.preventDefault);
    window.removeEventListener('wheel', wus.preventDefault);
    window.removeEventListener('keydown', wus.preventArrowKeys);
    if (wus.isMobileScreen()) {
        document.body.style["overflow"] = "auto"
    }
}

wus.preventDefault = function(event) {
    event.preventDefault();
}

wus.preventArrowKeys = function(event) {
    const keys = ['ArrowUp', 'ArrowDown'];
    if (keys.includes(event.key)) {
        event.preventDefault();
    }
}

wus.execLazyLoadingScript = function() {
    wus.showNewsletterButton()
}

wus.isCustomerConnected = function() {
    if (typeof window.WUS_CUSTOMER_EMAIL === "string") {
        return true;
    }

    return false;
}

wus.handleLoyaltyButton = function() {
    if (wus.isProductPage()) {
        return;
    }

    var buttonElem = document.getElementById("dsquaresIframeToggleButton");
    if (!buttonElem) {
        setTimeout(function() {
            wus.handleLoyaltyButton();
        }, 200);
        
        return;
    }

    function createOverlay() {
        const overlayDiv = document.createElement("div");
        overlayDiv.id = "dsq-overlay";

        document.body.appendChild(overlayDiv);

        overlayDiv.onclick = function() {
            localStorage.setItem("wus_loyalty_clicked", "true");
            const encodedRedirectPath = encodeURIComponent("/?open_loy=1");
            const loginPath = `/customer_authentication/login?return_to=${encodedRedirectPath}`;
            window.location.href = loginPath;
        }
    }

    function checkOpenDSQ() {
        const url = new URL(window.location.href);
        if (url.searchParams.has("open_loy")) {
            url.searchParams.delete("open_loy");
            buttonElem.click();
            localStorage.setItem("wus_loyalty_clicked", "true");
            window.history.replaceState({}, "", url);
        }
    }

    if (!wus.isCustomerConnected()) {
        createOverlay();
    } else {
        checkOpenDSQ();
    }
}

wus.handleSizeChart = function() {
    var sizeChartElem = document.querySelector('[id^="size-chart-"]');
    
    if (!sizeChartElem) {
        return;
    }

    var overflowContent = sizeChartElem.shadowRoot?.querySelector('[part="body"]')

    var zoomableDiv = sizeChartElem.querySelector(".prose");

    if (!zoomableDiv) {
        return;
    }

    const images = zoomableDiv.querySelectorAll('img');

    images.forEach((img) => {
        img.style.width = `100%`;
        img.style["max-width"] = `none`;
    });

    let lastTouches = [];
    let currentWidthPercentage = 100;

    const minPercentage = 100;
    const maxPercentage = 200;

    function getDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    function getCenter(touch1, touch2) {
        return {
            x: (touch1.clientX + touch2.clientX) / 2,
            y: (touch1.clientY + touch2.clientY) / 2
        };
    }

    zoomableDiv.addEventListener('touchstart', (event) => {
        if (event.touches.length === 2) {
            lastTouches = [event.touches[0], event.touches[1]];
        }
    });

    zoomableDiv.addEventListener('touchmove', (event) => {
        if (event.touches.length === 2) {
            event.preventDefault();
            const currentTouches = [event.touches[0], event.touches[1]];
            const initialDistance = getDistance(lastTouches[0], lastTouches[1]);
            const currentDistance = getDistance(currentTouches[0], currentTouches[1]);
            const zoomFactor = currentDistance / initialDistance;

            let newWidthPercentage = currentWidthPercentage * zoomFactor;

            newWidthPercentage = Math.max(minPercentage, Math.min(maxPercentage, newWidthPercentage));

            const center = getCenter(currentTouches[0], currentTouches[1]);

            const offsetX = (center.x + overflowContent.scrollLeft) / overflowContent.offsetWidth;
            const offsetY = (center.y + overflowContent.scrollTop) / overflowContent.offsetHeight;

            images.forEach((img) => {
                img.style.width = `${newWidthPercentage}%`;
            });

            const newScrollLeft = offsetX * overflowContent.scrollWidth - center.x;
            const newScrollTop = offsetY * overflowContent.scrollHeight - center.y;

            // overflowContent.scrollLeft = newScrollLeft;
            // overflowContent.scrollTop = newScrollTop;

            currentWidthPercentage = newWidthPercentage;
            lastTouches = currentTouches;
        }
    });

    zoomableDiv.addEventListener('touchend', () => {
        lastTouches = [];
    });
}

wus.fireScriptLazy = function() {
    var lazyLoadStarted = false

    document.addEventListener("click", startLazyLoad);
    document.addEventListener("scroll", startLazyLoad);
    document.addEventListener("touchstart", startLazyLoad);
    document.addEventListener("mousemove", startLazyLoad);

    function startLazyLoad() {
        if (lazyLoadStarted) {
            return
        }

        lazyLoadStarted = true

        setTimeout(function() {
            wus.execLazyLoadingScript()
        }, 100)
    }
}

wus.fire = function() {
    this.run()
}

wus.isProductPage = function() {
    return meta.page && meta.page.pageType === "product"
}

wus.isCollectionPage = function() {
    return meta.page && meta.page.pageType === "collection"
}

wus.isHomePage = function() {
    return meta.page && meta.page.pageType === "home"
}

wus.addProductPageClass = function() {
    document.body.classList.add("wus-product-page")
}

wus.runCollectionPage = function() {
    if (!wus.isCollectionPage()) {
        return
    }

    wus.handleFlashSaleCounterCollection();
}

wus.handleProductShare = function() {
    if (!wus.isProductPage()) {
        return;
    }

    let elem = document.querySelector(".wus-wishlist-product-share");
    if (!elem) {
        return;
    }

    elem.addEventListener("click", function(e) {
        e.preventDefault();
        let elem = document.querySelector(".product-info__native-share");
        elem.click();
    });
}

wus.handleWishList = function() {
    window.variant_name_id_selector = '[name=id]'
    window.custom_variant_change = '.shopify-product-form [name=id]'
    window.iwish_qvWrapper = '.quick-buy-drawer.show-close-cursor'
    
    function handleWishListCloseDrawerButton() {
        // return;
        let elem = document.querySelector("#iwish-drawer-root .wish-drawer-title");
        let currentClose = document.querySelector("#iwish-drawer-root .wish-drawer-title .mst-drawer-title-icon");

        if (!elem) {
            setTimeout(function() {
                handleWishListCloseDrawerButton();
            }, 200);
            return;
        }

        let closeButtonHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`;

        var closeButtonElem = document.createElement('button');
        closeButtonElem.classList.add("iwish-drawer-close-button");
        closeButtonElem.setAttribute("aria-label", "Close");
        closeButtonElem.innerHTML = closeButtonHTML;

        elem.appendChild(closeButtonElem);

        if (currentClose) {
            currentClose.style["display"] = "none";
        }

        setTimeout(function() {
            let newCloseButton = document.querySelector("#iwish-drawer-root .wish-drawer-title .iwish-drawer-close-button");
            if (newCloseButton) {
                newCloseButton.addEventListener("click", function(e) {
                    document.querySelector("#iwish-drawer-root .wish-drawer-title .mst-drawer-title-icon").click();
                });
            }
        }, 100);
    }

    function handleWishListButton() {
        var buttonElem = document.querySelector(".wus-wishtlist-icon");
        var headerButtonElem = document.querySelector("#wus-wishlist-selector-mobile");
        var iWishButtonElem = document.querySelector(".iwish-float-icon");

        if (!headerButtonElem || !buttonElem) {
            setTimeout(function() {
                handleWishListButton();
            }, 200);
            return;
        }

        buttonElem.addEventListener("click", function(e) {
            e.preventDefault();
            iWishButtonElem.click();
        })

        headerButtonElem.addEventListener("click", function(e) {
            e.preventDefault();
            iWishButtonElem.click();
        })
    }

    function observeWishListCounter() {
        var iWishCounterElem = document.querySelector(".iwish-counter");
        var wusWishListCountElem = document.querySelector(".wus-wishlist-count");
        var wusWishListHeaderCountElem = document.querySelector(".wus-wishlist-header-count");

        if (!iWishCounterElem || !wusWishListCountElem || !wusWishListHeaderCountElem) {
            setTimeout(function() {
                observeWishListCounter();
            }, 200);
            return;
        }

        function updateWishlistCounts() {
            var tc = iWishCounterElem?.textContent?.trim()

            if (typeof tc !== "string" || tc === "") {
                return
            }

            if (isNaN(tc)) {
                return
            }

            var tcn = parseInt(tc);

            if (tcn <= 0) {
                tcn = 0;
                localStorage.setItem("iWishCnt", "0");
                showHideWishlistButton("h");
            } else {
                showHideWishlistButton("s");
            }

            wusWishListCountElem.textContent = iWishCounterElem.textContent.trim();
            wusWishListHeaderCountElem.innerHTML = iWishCounterElem.textContent.trim();
        }

        var observer = new MutationObserver(function(mutationsList) {
            for (var mutation of mutationsList) {
                if (mutation.type === "characterData" || mutation.type === "childList") {
                    updateWishlistCounts()
                }
            }
        });

        observer.observe(iWishCounterElem, { characterData: true, childList: true, subtree: true });

        setTimeout(function() {
            updateWishlistCounts()
        }, 100);
    }

    function observeDrawerState() {
        const drawerElem = document.querySelector("#mst-iwish-drawer-root .react-side-draw");
    
        if (!drawerElem) {
            setTimeout(function() {
                observeDrawerState();
            }, 200);
            return;
        }
    
        function checkDrawerState() {
            if (!drawerElem.classList.contains("open")) {
                setTimeout(function() {
                    updateCartHeaderCount()
                }, 1500);
            }
        }
    
        const observer = new MutationObserver(() => {
            checkDrawerState();
        });
    
        observer.observe(drawerElem, { attributes: true, attributeFilter: ["class"] });
    
        checkDrawerState();
    }

    function updateCartHeaderCount() {
        var headerCountElem = document.querySelector(".header__cart-count cart-count.count-bubble");
        var cartCountElem = document.querySelector(".cart-drawer__inner cart-count.count-bubble");

        if (!headerCountElem || !cartCountElem) {
            return;
        }

        if (isNaN(cartCountElem.innerHTML)) {
            return
        }

        let count = parseInt(cartCountElem.innerHTML);

        headerCountElem.itemCount = count;
    }

    function showHideWishlistButton(type) {
        var elem = document.querySelector(".wus-wishtlist-icon");
        var elemHeader = document.querySelector(".wus-wishlist-header-count");

        if (!elem || !elemHeader) {
            return;
        }

        if (type === "s") {
            elemHeader.style["opacity"] = "1"
            elem.style["display"] = "block"
            setTimeout(function() {
                elem.style["opacity"] = "1"
            }, 20);
            
        } else {
            elemHeader.style["opacity"] = "0"
            elem.style["opacity"] = "0"
            setTimeout(function() {
                elem.style["display"] = "none"
            }, 450);
        }
    }

    function observeProductPageWishList() {
        const addWishlistButton = document.querySelector(".product-info .iWishAdd");
        const wusProductWishAddImage = document.querySelector("product-gallery .wus-wishlist-product-image")
        if (!addWishlistButton || !wusProductWishAddImage) {
            setTimeout(function() {
                observeProductPageWishList();
            }, 200);
            return;
        }
    
        function checkWishButtonClass() {
            if (addWishlistButton.classList.contains("iwishAdded")) {
                wusProductWishAddImage.classList.add("added");
            } else {
                wusProductWishAddImage.classList.remove("added");
            }
        }
    
        const observer = new MutationObserver(() => {
            checkWishButtonClass();
        });
    
        observer.observe(addWishlistButton, { attributes: true, attributeFilter: ["class"] });
    
        checkWishButtonClass();
    }

    function handleWishListProductPageAdd() {
        // const addWishlistButton = document.querySelector(".product-info .iwish-app-block-wrapper .iWishAdd");
        const wusProductWishAddImage = document.querySelector("product-gallery .wus-wishlist-product-image")
       
        if (!wusProductWishAddImage) {
            setTimeout(function() {
                handleWishListProductPageAdd();
            }, 200);
            return;
        }

        wusProductWishAddImage.addEventListener("click", function(e) {
            e.preventDefault();
            // addWishlistButton.click();
            let button = document.querySelector(".product-info .iWishAdd");
            if (button) {
                button.click();
            }
        })
    }

    if (wus.isProductPage()) {
        observeProductPageWishList()
        handleWishListProductPageAdd()
    }

    handleWishListButton();
    observeWishListCounter();
    observeDrawerState();
    handleWishListCloseDrawerButton();
}

wus.handleJQ = function() {
    if (!window.jQuery) {
        setTimeout(function() {
            wus.handleJQ();
        }, 200);
        return;
    }

    window.$ = window.jQuery;
}

wus.handleProductCardInstallmentButton = function() {
    let elems = document.querySelectorAll(".wus-pay-as-low-as-card-button")
    if (!elems) {
        return
    }

    for (let i = 0; i < elems.length; i++) {
        let elem = elems[i]
        if (!elem) {
            continue
        }

        wus.handleProductInstallmentButton(elem);
    }
    
}

wus.handleProductInstallmentButton = function(elem) {
    if (!elem) {
        elem = document.querySelector(".wus-pay-as-low-as-button")
    }

    if (!elem) {
        return
    }

    let buttonText = elem.getAttribute("data-text");
    let productPrice = elem.getAttribute("data-product-price");

    if (isNaN(productPrice)) {
        return
    }

    if (typeof window.getLowestOfferOverall !== "function") {
        return;
    }

    let intProductPrice = parseInt(productPrice);

    if (isNaN(intProductPrice)) {
        return
    }

    let price = window.getLowestOfferOverall(intProductPrice);

    if (!price) {
        return
    }

    if (!price.monthlyPayment) {
        return
    }

    // let priceFormatted = wus.formatPrice(price.monthlyPayment);
    let priceFormatted = price.monthlyPayment;

    buttonText = buttonText.replace("PRICE_REPLACE", priceFormatted);

    let icon = document.querySelector(".wus-pay-as-low-icon");

    let arrowIcon = document.querySelector(".wus-pay-as-low-arrow-right");

    if (wus.isRTL()) {
        arrowIcon = document.querySelector(".wus-pay-as-low-arrow-left");
    }

    let iconHTML = icon.innerHTML;
    if (iconHTML) {
        buttonText = iconHTML + " " + buttonText + " " + arrowIcon.innerHTML;
    }

    elem.innerHTML = buttonText;
    elem.style["display"] = "inline-block";
}

wus.runProductPage = function() {
    if (!wus.isProductPage()) {
        return
    }

    wus.addProductPageClass()
    wus.handleSizeChart()

    wus.handleProductInstallmentButton()

    wus.handleProductOptions();

    wus.handleProductQuickBuyButtons();

    wus.handleProductShare();
}

wus.startCountdown = function(element, startHour, startMinute, durationMinutes, beforeStart, onStart, onEnd) {
    let now = new Date();
    let startTime = new Date();
    startTime.setHours(startHour, startMinute, 0, 0);
    
    let endTime = new Date(startTime.getTime() + durationMinutes * 60 * 1000);

    if (now > endTime) {
        startTime.setDate(startTime.getDate() + 1);
        endTime.setDate(endTime.getDate() + 1);
    }

    let hasStarted = false;
    let beforeStartCalled = false;
    
    function updateCountdown() {
        let currentTime = new Date();

        if (currentTime < startTime) {
            if (element) {
                element.innerText = "Countdown not started yet";
            }
            
            if (!beforeStartCalled && typeof beforeStart === "function") {
                beforeStart();
                beforeStartCalled = true;
            }
            return;
        }
        
        if (!hasStarted) {
            hasStarted = true;
            if (typeof onStart === "function") {
                onStart();
            }
        }
        
        let timeLeft = endTime - currentTime;
        
        if (timeLeft <= 0) {
            if (element) {
                element.innerText = "00:00:00";
            }
            
            clearInterval(interval);
            if (typeof onEnd === "function") {
                onEnd();
            }
            return;
        }
        
        let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        let seconds = Math.floor((timeLeft / 1000) % 60);
        
        let timeString = String(hours).padStart(2, '0') + ":" + String(minutes).padStart(2, '0') + ":" + String(seconds).padStart(2, '0');
        // console.log(timeString);

        if (element) {
            element.innerText = timeString;
        }
    }
    
    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

wus.startCountdownUntil = function(element, endHour, endMinute, onEnd) {
    let now = new Date();

    let endTime = new Date();
    endTime.setHours(endHour, endMinute, 0, 0);

    if (now >= endTime) {
        endTime.setDate(endTime.getDate() + 1);
    }

    function updateCountdown() {
        let currentTime = new Date();
        let timeLeft = endTime - currentTime;

        if (timeLeft <= 0) {
            element.innerText = "00:00:00";
            clearInterval(interval);
            if (typeof onEnd === "function") {
                onEnd();
            }
            return;
        }

        let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        let seconds = Math.floor((timeLeft / 1000) % 60);

        element.innerText =
            String(hours).padStart(2, '0') + ":" +
            String(minutes).padStart(2, '0') + ":" +
            String(seconds).padStart(2, '0');
    }

    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

wus.startCountdownUntilDate = function(element, endDate, onStart, onEnd) {
    let now = new Date();

    let hasStarted = false;

    let endTime = endDate;

    if (!isValidDateWUS(endTime)) {
        return;
    }

    function updateCountdown() {
        let currentTime = new Date();
        let timeLeft = endTime - currentTime;

        if (timeLeft <= 0) {
            element.innerText = "00:00:00";
            clearInterval(interval);
            if (typeof onEnd === "function") {
                onEnd();
            }
            return;
        }

        if (!hasStarted) {
            hasStarted = true;
            if (typeof onStart === "function") {
                onStart();
            }
        }

        let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        let seconds = Math.floor((timeLeft / 1000) % 60);

        element.innerText =
            String(hours).padStart(2, '0') + " : " +
            String(minutes).padStart(2, '0') + " : " +
            String(seconds).padStart(2, '0');
    }

    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

wus.runCountdownUntilDate = function(element, endDate, onStart, onEnd) {
    let hasStarted = false;

    let endTime = endDate;

    if (!isValidDateWUS(endTime)) {
        return;
    }

    if (element.classList.contains("running")) {
        return;
    }

    const hoursElem = element.querySelector(".wus-product-countdown-timer-hours");
    const minutesElem = element.querySelector(".wus-product-countdown-timer-minutes");
    const secondsElem = element.querySelector(".wus-product-countdown-timer-seconds");

    function updateCountdown() {
        let currentTime = new Date();
        let timeLeft = endTime - currentTime;

        if (timeLeft <= 0) {
            hoursElem.innerText = "00";
            minutesElem.innerText = "00";
            secondsElem.innerText = "00";
            clearInterval(interval);
            element.classList.remove("running");
            if (typeof onEnd === "function") {
                onEnd();
            }
            return;
        }

        if (!hasStarted) {
            hasStarted = true;
            element.classList.add("running");
            if (typeof onStart === "function") {
                onStart();
            }
        }

        let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
        let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
        let seconds = Math.floor((timeLeft / 1000) % 60);

        hoursElem.innerText = String(hours).padStart(2, '0');
        minutesElem.innerText = String(minutes).padStart(2, '0');
        secondsElem.innerText = String(seconds).padStart(2, '0');
    }

    let interval = setInterval(updateCountdown, 1000);
    updateCountdown();
}

wus.handleCollectionPageTabs = function() {
    let HTML_TEMPLATE = `
    <button type="button" 
            data-type-label="LABEL" 
            class="wus-product-filters-tabs-item-button wus-collections-tabs-item-button ACTIVE_CLASS">TITLE_COUNT</button>
    `;

    let collectionTabs = document.querySelector(".wus-product-filter-tabs");

    if (!collectionTabs) {
        return;
    }

    let listButtons = document.querySelector(".wus-product-filters-tabs-list-buttons");

    if (!listButtons) {
        return;
    }

    let filterOptionsList = wus.getFilterOptionsList("accordion-filter-p-product_type");

    if (!filterOptionsList) {
        return;
    }

    if (filterOptionsList.length <= 1) {
        return;
    }

    var allButtonsHTML = "";

    filterOptionsList.forEach(function(option) {
        // let buttonHTML = HTML_TEMPLATE.replace("TITLE_COUNT", option.label + " (" + option.quantity + ")");
        let buttonHTML = HTML_TEMPLATE.replace("TITLE_COUNT", option.label);
        buttonHTML = buttonHTML.replace("LABEL", option.label);

        if (option.isActive) {
            buttonHTML = buttonHTML.replace("ACTIVE_CLASS", "active");
        } else {
            buttonHTML = buttonHTML.replace("ACTIVE_CLASS", "");
        }
        
        allButtonsHTML += buttonHTML;
    });

    setTimeout(function() {
        let activeButton = listButtons.querySelector(".wus-collections-tabs-item-button.active");
        if (activeButton) {
            activeButton.scrollIntoView({
                behavior: "auto",
                block: "nearest",
                inline: "center"
            });
        }
    }, 10);

    if (allButtonsHTML.length > 0) {
        listButtons.innerHTML = allButtonsHTML;
        collectionTabs.style.display = "block";
    }

    let listButtonsElems = listButtons.querySelectorAll(".wus-product-filters-tabs-item-button");

    if (!listButtonsElems) {
        return;
    }

    async function handleButtonClick(button) {
        if (button.classList.contains("active")) {
            button.classList.remove("active");
        } else {
            listButtonsElems.forEach(function(button) {
                button.classList.remove("active");
            });

            button.classList.add("active");
        }
        
        let facetsDrawer = document.querySelector("#facets-drawer");
        facetsDrawer.style["opacity"] = 0;

        let filtersParent = document.querySelector("#main .collection__facets #facet-form #accordion-filter-p-product_type")

        if (window.innerWidth < 999) {
            filtersParent = document.querySelector("#facets-drawer #facet-form #accordion-filter-p-product_type");
        }

        let typeLabel = button.getAttribute("data-type-label");

        let allCheckBoxes = filtersParent.querySelectorAll("input[type='checkbox']");

        let currentElemInput = filtersParent.querySelector(`input[value="${typeLabel}"]`);
        let currentElemLabel = filtersParent.querySelector(`label[for="${currentElemInput.id}"]`);

        if (currentElemInput.checked) {
            currentElemLabel.click();
        } else {
            allCheckBoxes.forEach(function(checkbox) {
                checkbox.checked = false;
            });
            currentElemLabel.click();
        }

        if (window.innerWidth < 999) {
            let bodyElem = document.querySelector("html");
            bodyElem.classList.add("wus-hide-drawer-facets");

            await new Promise(resolve => setTimeout(resolve, 20));

            let floatingFacetButton = document.querySelector("facet-floating-filter button");

            if (floatingFacetButton) {
                floatingFacetButton.click();
            }

            await new Promise(resolve => setTimeout(resolve, 250));

            let applyButton = document.querySelector("#facets-drawer .facets-drawer__floating-apply button"); 
            applyButton.click();

            await new Promise(resolve => setTimeout(resolve, 250));
            // let bodyElem = document.querySelector("html");
            bodyElem.classList.remove("wus-hide-drawer-facets");
        }
    }

    listButtonsElems.forEach(function(button) {
        button.addEventListener("click", function() {
            handleButtonClick(button);
        });
    });
}

wus.handleCollectionTabs = function() {
    let collectionTabs = document.querySelector(".wus-product-filter-tabs");

    if (!collectionTabs) {
        return;
    }

    wus.handleCollectionPageTabs();

    return;

    let __wus_lastUrl = location.href;
    setInterval(function() {
        if (location.href !== __wus_lastUrl) {
            console.log("url changed");
            __wus_lastUrl = location.href;
            if (typeof wus.handleCollectionPageTabs === "function") {
                setTimeout(function() {
                    wus.handleCollectionPageTabs();
                }, 2000);
            }
        }
    }, 200);
}

wus.getFilterOptionsList = function(filterElemId) {
    let filterElem = document.getElementById(filterElemId);

    if (!filterElem) {
        return;
    }

    let labels = filterElem.querySelectorAll(".checkbox-list .checkbox-container label");

    if (!labels) {
        return;
    }

    let optionsList = [];

    labels.forEach(function(label) {
        let text = label.textContent.trim();
        text = text.replace("(", "").replace(")", "");
        let textParts = text.split(" ");
        let checkBoxId = label.getAttribute("for");
        let checkBoxInput = filterElem.querySelector(`#${checkBoxId}`);
        
        if (textParts.length < 2) {
            return;
        }
        let quantity = textParts[textParts.length - 1];
        quantity = parseInt(quantity);
        if (isNaN(quantity)) {
            return;
        }
        let textWithoutQuantity = textParts.slice(0, -1).join(" ");
        let isActive = false;
        if (checkBoxInput.checked) {
            isActive = true;
        }
        optionsList.push({
            label: textWithoutQuantity,
            quantity: quantity,
            isActive: isActive
        });
    });

    //sort by quantity from highest to lowest
    optionsList.sort(function(a, b) {
        return b.quantity - a.quantity;
    });

    return optionsList;
}


wus.handleFlashSaleCounterCollection = function() {
    if (!window.location.href.includes("flash-sale")) {
        return;
    }

    let counterElem = document.querySelector(".flash-sale-counter");

    if (!counterElem) {
        setTimeout(function() {
            wus.handleFlashSaleCounterCollection();
        }, 200);
        return;
    }

    wus.startCountdownUntil(counterElem, 20, 0);
}

wus.handleLifestyleLink = function() {
    if (!wus.isMobileScreen()) {
        return
    }

    var imageBase = "https://cdn.shopify.com/s/files/1/0413/0416/2471/files/lifestyle_circle_3.gif?v=1743259768"

    var sideMenuElem = document.querySelector("#header-sidebar-menu")
    if (!sideMenuElem) {
        setTimeout(function() {
            wus.handleLifestyleLink()
        }, 100)
        return
    }

    function handleMenuOpenClose() {
        if (sideMenuElem.classList.contains("show-close-cursor")) {
            setTimeout(function() {
                setLS()
            }, 0);
            
        } else {
            removeLS()
        }
    }

    function iniLS() {
        var elem = document.querySelector("#header-sidebar-menu a[href*=lifestyle]");
        if (!elem) {
            return
        }

        const newImg = document.createElement('img');

        newImg.src = imageBase;
        newImg.id = 'ls-circle';

        elem.prepend(newImg);
        newImg.style.opacity = 0;
    }

    function setLS() {
        var elem = document.querySelector("#header-sidebar-menu a[href*=lifestyle]");
        if (!elem) {
            return
        }

        const img = document.querySelector("#ls-circle");

        if (img) {
            let randomNumber = Math.floor(Math.random() * 1000000);
            img.src = imageBase + '#' + randomNumber;
            img.onload = function() {
                setTimeout(function() {
                    img.style.opacity = 1;
                }, 200);
            }

            return;
        }

    }

    function removeLS() {
        var elem = document.querySelector("#header-sidebar-menu a[href*=lifestyle]");
        if (!elem) {
            return
        }

        const img = document.querySelector("#ls-circle");
        if (img) {
            img.style.opacity = 0;
        }
    }

    const observer = new MutationObserver(() => {
        handleMenuOpenClose();
    });

    observer.observe(sideMenuElem, { attributes: true, attributeFilter: ["class"] });

    handleMenuOpenClose();

    iniLS();
}

wus.handleLastPieces = function() {
    if (wus.isHomePage()) {
        return;
    }
    
    if (!window.location.href.includes("collections/last-pieces")) {
        return;
    }

    var imageBase = "https://cdn.shopify.com/s/files/1/0413/0416/2471/files/lifestyle_circle_3.gif?v=1743259768"

    if (!wus.isMobileScreen()) {
        var filterElem = document.querySelector(".collection__facets #accordion-filter-v-option-size")

        if (!filterElem) {
            return;
        }

        filterElem.style.position = "relative";

        const summaryElem = filterElem.querySelector("summary");

        if (!summaryElem) {
            return;
        }

        const newImg = document.createElement('img');

        newImg.src = imageBase;
        newImg.classList.add("last-pieces-circle");
        newImg.style.opacity = 0;

        filterElem.prepend(newImg);

        setTimeout(function() {
            newImg.style.opacity = 1;
        }, 200);
        
    } else {

    }
}

wus.handleFlashSaleCounter = function() {
    let mainElem = document.querySelector("#shopify-section-template--20858382811374__slideshow_9XyeEe");

    if (!mainElem) {
        setTimeout(function() {
            wus.handleFlashSaleCounter();
        }, 200);
        return;
    }

    let flashSaleCounterDiv = document.createElement("div");
    flashSaleCounterDiv.classList.add("counter-flash-sale");
    flashSaleCounterDiv.innerHTML = "00:00:00";
    flashSaleCounterDiv.style.display = "none";
    mainElem.appendChild(flashSaleCounterDiv);

    wus.startCountdown(flashSaleCounterDiv, 20, 0, 240, function() {
        // mainElem.style.display = "none";
        mainElem.classList.add("wus-flash-sale-counter-wait");
    }, function() {
        // mainElem.style.display = "block";
        mainElem.classList.remove("wus-flash-sale-counter-wait");
    }, function() {
        // mainElem.style.display = "none";
        mainElem.classList.add("wus-flash-sale-counter-wait");
    });
}

wus.handleCheckoutFixTemp = function() {
    var currentHref = window.location.href;

    if (currentHref.includes("checkout")) {
        return;
    }
    
    deleteLocalStorageKeyWUS("__ui");
}

wus.runHomePage = function() {
    if (!wus.isHomePage()) {
        return
    }

    wus.handleFlashSaleCounter()
}

wus.handleProductCounters = function() {
    function run() {
        let productCounters = document.querySelectorAll(".wus-product-countdown");

        if (!productCounters) {
            return;
        }
        
        productCounters.forEach(function(counter) {
            let dateEnd = counter.getAttribute("data-date-end");
            
            var dateToEnd = new Date(dateEnd);

            if (!isValidDateWUS(dateToEnd)) {
                return;
            }

            wus.runCountdownUntilDate(counter, dateToEnd, function() {
                counter.classList.add("show");
            }, function() {
                counter.classList.remove("show");
            });
        });
    }

    run();

    setInterval(run, 2000);
}

wus.handleRefundForms = function() {
    if (!window.location.href.includes("pages/refund-request")) {
        // return;
    }

    let refundForms = document.querySelectorAll(".wus-refund-request-form");

    if (!refundForms) {
        return;
    }
    
    function messageAndRefresh(message) {
        alert(message);
        setTimeout(function() {
            window.location.reload();
        }, 1000);
    }

    function handleRefundMethodChange(form) {
        let refundMethod = form.querySelector("select[name='contact[refundMethod]']");

        if (!refundMethod) {
            return;
        }

        refundMethod.addEventListener("change", function() {
            let refundMethodValue = refundMethod.value;

            let walletContainer = form.querySelector(".wus-refund-request-wallet-number-container");
            let bankContainer = form.querySelector(".wus-refund-request-wallet-bank-container");

            let bankInput = form.querySelector("[name='contact[bank]']");
            let accountNumberInput = form.querySelector("[name='contact[accountNumber]']");
            let walletNumberInput = form.querySelector("[name='contact[walletNumber]']");
            let walletAccountNameInput = form.querySelector("[name='contact[walletAccountName]']");
            let bankAccountNameInput = form.querySelector("[name='contact[bankAccountName]']");
            
            if (refundMethodValue === "Bank") {
                bankContainer.style.display = "grid";
                walletContainer.style.display = "none";

                bankInput.setAttribute("required", "required");
                accountNumberInput.setAttribute("required", "required");
                bankAccountNameInput.setAttribute("required", "required");
                walletNumberInput.removeAttribute("required");
                walletAccountNameInput.removeAttribute("required");
                
            } else if (refundMethodValue === "Wallet") {
                bankContainer.style.display = "none";
                walletContainer.style.display = "grid";

                bankInput.removeAttribute("required");
                accountNumberInput.removeAttribute("required");
                bankAccountNameInput.removeAttribute("required");
                walletNumberInput.setAttribute("required", "required");
                walletAccountNameInput.setAttribute("required", "required");
            } else {
                bankContainer.style.display = "none";
                walletContainer.style.display = "none";

                bankInput.removeAttribute("required");
                accountNumberInput.removeAttribute("required");
                walletNumberInput.removeAttribute("required");
            }
        });
    }

    function handleRefundForm(form) {
        const successMessage = form.querySelector(".wus-success-message");
        const errorMessage = form.querySelector(".wus-error-message");

        form.addEventListener('submit', (e) => {
            e.preventDefault();
            let scriptURL = form.getAttribute("action");

            const formData = new FormData(form);
        
            fetch(scriptURL, {
              method: 'POST',
              body: formData
            })
            .then(response => response.json())
            .then(data => {
              if (data.result === 'success') {
                form.reset();
                messageAndRefresh(successMessage.textContent);
              } else {
                messageAndRefresh(errorMessage.textContent);
              }
            })
            .catch(error => {
              messageAndRefresh(errorMessage.textContent);
            });
        });
    }

    refundForms.forEach(function(form) {
        handleRefundForm(form);
        handleRefundMethodChange(form);
    });
}

wus.preloadLuckyImage = function() {
    if (!wus.isHomePage()) {
        return;
    }

    let imageNewSrc = "https://cdn.shopify.com/s/files/1/0413/0416/2471/files/lucky_hour_image.png?v=1761820557"

    let imagePreload = new Image();
    imagePreload.src = imageNewSrc;
}

wus.handleLuckyHourParent = function(parentElem) {
    let imageNewSrc = "https://cdn.shopify.com/s/files/1/0413/0416/2471/files/lucky_hour_image.png?v=1761820557"

    // let parentElem = document.querySelector(".image-link-blocks__item [href*=lucky-hour]");

    if (!parentElem) {
        return;
    }

    let imageElem = parentElem.querySelector("img");
    let originalImageSrc = imageElem.src;

    imageElem.style.opacity = 0;

    if (!imageElem) {
        return;
    }

    let imagePreload = new Image();
    imagePreload.src = imageNewSrc;

    imagePreload.onload = function() {
        imageElem.style.opacity = 1;
    }

    imageElem.setAttribute("srcset", "");
    imageElem.setAttribute("src", imageNewSrc);

    let luckyHourCounterDiv = document.createElement("div");
    luckyHourCounterDiv.classList.add("lucky-hour-counter");
    luckyHourCounterDiv.innerHTML = "00:00:00";
    parentElem.appendChild(luckyHourCounterDiv);

    luckyHourCounterDiv.style.display = "none";

    let originalHref = parentElem.getAttribute("href");

    function handleClick(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    function resetImage() {
        imageElem.setAttribute("src", originalImageSrc);
        imageElem.style.opacity = 1;
        luckyHourCounterDiv.style.display = "none";
        parentElem.setAttribute("href", originalHref);
        parentElem.removeEventListener("click", handleClick);
        parentElem.style["pointer-events"] = "auto";
    }

    function showCounter() {
        luckyHourCounterDiv.style.display = "block";
        imageElem.setAttribute("srcset", "");
        imageElem.setAttribute("src", imageNewSrc);
        parentElem.setAttribute("href", "#");
        parentElem.addEventListener("click", handleClick);
        parentElem.style["pointer-events"] = "none";
    }

    let targetHour = 21;
    let targetMinutes = 0;
    let durationMinutes = 599;

    let currentHour = new Date().getHours();
    let currentMinutes = new Date().getMinutes();
    let nubmerOfHoursToEnd = targetHour - currentHour;

    if (nubmerOfHoursToEnd <= 0) {
        nubmerOfHoursToEnd = 24 + nubmerOfHoursToEnd;
    }

    let numberOfMinutesToEnd = nubmerOfHoursToEnd * 60 - currentMinutes;

    console.log(nubmerOfHoursToEnd, currentHour, currentMinutes, numberOfMinutesToEnd);
    // console.log(targetHour, 0, 599);

    wus.startCountdown(luckyHourCounterDiv, currentHour, currentMinutes, numberOfMinutesToEnd, function() {
        // console.log("before start");
        resetImage()
    }, function() {
        // console.log("after start");
        showCounter()
    }, function() {
        // resetImage()
    })

    wus.startCountdown(null, targetHour, targetMinutes, durationMinutes, function() {
        return;
    }, function() {
        resetImage();
    }, function() {
        return;
    });
}

wus.handleLuckyHour = function() {
    if (!wus.isHomePage()) {
        // return;
    }

    let parentElems = document.querySelectorAll(".image-link-blocks__item [href*=lucky-hour]");

    if (!parentElems) {
        return;
    }

    parentElems.forEach(function(parentElem) {
        wus.handleLuckyHourParent(parentElem);
    });
}

wus.handleLoyaltyArrow = function() {
    if (!wus.isHomePage()) {
        return;
    }

    let isClickedBefore = false;

    let loyaltyClickedBefore = localStorage.getItem("wus_loyalty_clicked");

    if (loyaltyClickedBefore && loyaltyClickedBefore === "true") {
        isClickedBefore = true;
    }

    if (isClickedBefore) {
        return;
    }

    let elem = document.querySelector(".wus-loyalty-arrow");
    let overlayElem = document.querySelector(".wus-loyalty-arrow-overlay");
    let textRippleElem = document.querySelector(".wus-loyalty-arrow-overlay-text-ripple");
    let textElem = document.querySelector(".wus-loyalty-arrow-overlay-text");

    if (!elem || !overlayElem) {
        return;
    }

    let loyaltyElem = document.querySelector("#dsquaresIframeToggleButton");
    
    if (!loyaltyElem) {
        setTimeout(function() {
            wus.handleLoyaltyArrow();
        }, 200);
        return;
    }

    loyaltyElem.addEventListener("click", function() {
        localStorage.setItem("wus_loyalty_clicked", "true");
        elem.style.display = "none";
        clearInterval(fdInterval);
    });

    function handleScrollVisibility() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const documentHeight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.clientHeight,
            document.documentElement.scrollHeight,
            document.documentElement.offsetHeight
        );
        const windowHeight = window.innerHeight;
        const scrollableHeight = documentHeight - windowHeight;
        const scrollPercentage = (scrollTop / scrollableHeight) * 100;

        if (scrollPercentage > 10) {
            elem.style.display = "none";
        } else {
            elem.style.display = "block";
        }
    }

    // elem.style.display = "block";
    overlayElem.style.display = "block";
    textRippleElem.style.display = "block";
    textElem.style.display = "block";

    overlayElem.style["z-index"] = "99990";
    elem.style["z-index"] = "99991";
    textRippleElem.style["z-index"] = "99992";
    textElem.style["z-index"] = "99993";

    var fdInterval = setInterval(function() {
        const fcFrameElem = document.querySelector("#fc_frame, #fc_frame.fc-widget-normal");

        if (fcFrameElem) {
            fcFrameElem.style["z-index"] = "99980";
        }
    }, 100);

    overlayElem.onclick = function() {
        localStorage.setItem("wus_loyalty_clicked", "true");
        elem.style.display = "none";
        overlayElem.style.display = "none";
        textRippleElem.style.display = "none";
        textElem.style.display = "none";
        clearInterval(fdInterval);
    };

    // handleScrollVisibility();

    // document.addEventListener("scroll", handleScrollVisibility);
}

wus.getHiddenProductInfo = function(parentElem) {
    if (!wus.isProductPage() && !parentElem) {
        return null;
    }
    
    let hiddenProductInfo = parentElem.querySelector(".wus-product-hidden-info");
    
    if (!hiddenProductInfo) {
        return null;
    }

    let productId = hiddenProductInfo.getAttribute("data-product-id");
    let productFamily = hiddenProductInfo.getAttribute("data-product-family");
    let productSubfamily = hiddenProductInfo.getAttribute("data-product-subfamily");
    let productGender = hiddenProductInfo.getAttribute("data-product-gender");
    let productAgegroup = hiddenProductInfo.getAttribute("data-product-agegroup");

    return {
        productId: productId,
        productFamily: productFamily,
        productSubfamily: productSubfamily,
        productGender: productGender,
        productAgegroup: productAgegroup
    };
}

wus.fetchProductOptions = async function(productSubfamily, productGender, productAgegroup) {
    if (!productSubfamily || !productGender) {
        return null;
    }

    // let url = 'https://api.wayupsports.com/api/shy/get-product-variants?sub_family=[WUS_SUB_FAMILY]&gender=[WUS_GENDER]'
    let url = 'https://store-api.wayupsports.com/api/shy/get-product-variants?sub_family=[WUS_SUB_FAMILY]&gender=[WUS_GENDER]'
    url = url.replace("[WUS_SUB_FAMILY]", productSubfamily);
    url = url.replace("[WUS_GENDER]", productGender);

    if (typeof productAgegroup === "string" && productAgegroup.length > 0) {
        url += "&age_group=" + productAgegroup;
    }

    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "ngrok-skip-browser-warning": "1"
            }
        }); 

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        if (!data) {
            return null;
        }

        if (!data.success) {
            return null;
        }

        if (!data.data) {
            return null;
        }

        if (!data.data.products) {
            return null;
        }

        return data.data.products;
    } catch (error) {
        console.error("Fetch error:", error);
        return null;
    }
}

wus.showLoadingOverlay = function() {
    let loadingOverlay = document.querySelector(".wus-loading-overlay");
    loadingOverlay.classList.add("show");
}

wus.hideLoadingOverlay = function() {
    let loadingOverlay = document.querySelector(".wus-loading-overlay");
    loadingOverlay.classList.remove("show");
}

wus.handleProductOptions = async function() {
    if (!wus.isProductPage()) {
        return;
    }

    let mainElem = document.querySelector(".wus-product-options-main");

    if (!mainElem) {
        return;
    }

    let parentElem = document.querySelector(".product");
    
    let hiddenProductInfo = wus.getHiddenProductInfo(parentElem);

    if (!hiddenProductInfo) {
        return;
    }

    let productId = hiddenProductInfo.productId;
    let productFamily = hiddenProductInfo.productFamily;
    let productSubfamily = hiddenProductInfo.productSubfamily;
    let productGender = hiddenProductInfo.productGender;
    let productAgegroup = hiddenProductInfo.productAgegroup;

    let PRODUCT_OPTION_ITEM_HTML = `
        <div class="wus-product-option">
            <a href="[PRODUCT_URL]" class="[PRODUCT_ACTIVE_CLASS]">
                <img src="[PRODUCT_IMAGE]" alt="[PRODUCT_NAME]" />
            </a>
        </div>
    `;

    let products = await wus.fetchProductOptions(productSubfamily, productGender, productAgegroup);

    if (!products) {
        return;
    }

    if (products.length <= 1) {
        return;
    }

    products.forEach(function(product) {
        let url = `/products/${product.handle}`;
        let imageUrlString = product.featuredImage;

        let imageUrl = new URL(imageUrlString);
        imageUrl.searchParams.set("width", 200);

        let imageUrlHref = imageUrl.href;

        let name = product.title;

        let productHandle = null;

        if (meta) {
            if (meta.product && meta.product.handle) {
                productHandle = meta.product.handle;
            }
        }

        let isActive = product.handle === productHandle;

        let productItemHTML = PRODUCT_OPTION_ITEM_HTML.replace("[PRODUCT_URL]", url)
                                                       .replace("[PRODUCT_IMAGE]", imageUrlHref)
                                                       .replace("[PRODUCT_NAME]", name);

        if (isActive) {
            productItemHTML = productItemHTML.replace("[PRODUCT_ACTIVE_CLASS]", "active");
        } else {
            productItemHTML = productItemHTML.replace("[PRODUCT_ACTIVE_CLASS]", "");
        }

        mainElem.innerHTML += productItemHTML;
    });

    let productOptions = document.querySelectorAll(".wus-product-option a");

    if (!productOptions) {
        return;
    }

    productOptions.forEach(function(productOption) {
        productOption.addEventListener("click", function(e) {
            let url = this.getAttribute("href");
            e.preventDefault();
            e.stopPropagation();
            // wus.showLoadingOverlay();
            setTimeout(function() {
                window.location.href = url;
            }, 0);
        });
    });
}

wus.startHandleOptionsProductCards = async function() {
    while (true) {
        await wus.handleOptionsProductCards();
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
}

wus.handleOptionsProductCards = async function() {
    let productCardElems = document.querySelectorAll(".product-card");

    if (!productCardElems) {
        return;
    }

    // Do 4 at a time
    for (let i = 0; i < productCardElems.length; i += 4) {
        const slice = Array.prototype.slice.call(productCardElems, i, i + 4);

        await Promise.all(
            slice.map(async (productCardElem) => {
                if (!productCardElem) return;
                await wus.handleOptionsProductCard(productCardElem);
            })
        );

        await new Promise(resolve => setTimeout(resolve, 50));
    }

}

wus.handleOptionsProductCard = async function(productCardElem) {
    let productInfo = wus.getHiddenProductInfo(productCardElem);
    let mainProductCardElem = productCardElem.closest(".product-card");

    if (!productInfo) {
        return;
    }

    let productId = productInfo.productId;
    let productFamily = productInfo.productFamily;
    let productSubfamily = productInfo.productSubfamily;
    let productGender = productInfo.productGender;
    let productAgegroup = productInfo.productAgegroup;

    let mainProductHandle = mainProductCardElem.getAttribute("handle");

    if (!mainProductHandle) {
        return;
    }

    let mainElem = productCardElem.querySelector(".wus-product-card-options-list");


    if (mainElem.classList.contains("wus-handled-options")) {
        return;
    }

    mainElem.classList.add("wus-handled-options");

    if (!mainElem) {
        return;
    }

    let products = await wus.fetchProductOptions(productSubfamily, productGender, productAgegroup);

    if (!products) {
        return;
    }

    if (products.length <= 1) {
        return;
    }

    let PRODUCT_OPTION_ITEM_HTML = `
        <div class="wus-product-card-option [PRODUCT_ACTIVE_CLASS]" data-product-title="[PRODUCT_TITLE]" 
                                             data-product-image-1="[PRODUCT_IMAGE_1]"
                                             data-product-image-2="[PRODUCT_IMAGE_2]"
                                             data-product-price="[PRODUCT_PRICE]"
                                             data-product-compare-price="[PRODUCT_COMPARE_PRICE]"
                                             data-product-handle="[PRODUCT_HANDLE]">
            <img src="[PRODUCT_IMAGE]" alt="[PRODUCT_NAME]" />
        </div>
    `;

    let arrowLeftElem = productCardElem.querySelector(".wus-product-card-options-arrow-left");
    let arrowRightElem = productCardElem.querySelector(".wus-product-card-options-arrow-right");

    if (!arrowLeftElem || !arrowRightElem) {
        return;
    }

    arrowLeftElem.addEventListener("click", function() {
        mainElem.scrollBy({ left: -70, behavior: 'smooth' });
        arrowRightElem.classList.remove("reached-end");
        setTimeout(function() {
            if (mainElem.scrollLeft <= 0) {
                arrowLeftElem.classList.add("reached-end");
            } else {
                arrowLeftElem.classList.remove("reached-end");
            }
        }, 200);
    });

    arrowRightElem.addEventListener("click", function() {
        mainElem.scrollBy({ left: 70, behavior: 'smooth' });
        arrowLeftElem.classList.remove("reached-end");
        setTimeout(function() {
            if (mainElem.scrollLeft >= mainElem.scrollWidth - mainElem.offsetWidth) {
                arrowRightElem.classList.add("reached-end");
            } else {
                arrowRightElem.classList.remove("reached-end");
            }
        }, 200);
    });

    products.forEach(function(product) {
        let productHandle = product.handle;
        let imageUrlString = product.featuredImage;

        let imageUrl = new URL(imageUrlString);
        imageUrl.searchParams.set("width", 100);

        let imageUrlHref = imageUrl.href;

        let image1 = product.images[0] + "?width=400";
        let image2 = product.images[1] + "?width=400" || image1;

        let name = product.title;

        let price = product.variants[0].price;
        let comparePrice = product.variants[0].compareAtPrice;

        let productItemHTML = PRODUCT_OPTION_ITEM_HTML.replace("[PRODUCT_HANDLE]", productHandle)
                                                       .replace("[PRODUCT_IMAGE]", imageUrlHref)
                                                       .replace("[PRODUCT_IMAGE_1]", image1)
                                                       .replace("[PRODUCT_IMAGE_2]", image2)
                                                       .replace("[PRODUCT_PRICE]", price)
                                                       .replace("[PRODUCT_TITLE]", name)
                                                       .replace("[PRODUCT_COMPARE_PRICE]", comparePrice)
                                                       .replace("[PRODUCT_NAME]", name);

        if (productHandle === mainProductHandle) {
            productItemHTML = productItemHTML.replace("[PRODUCT_ACTIVE_CLASS]", "active");
        } else {
            productItemHTML = productItemHTML.replace("[PRODUCT_ACTIVE_CLASS]", "");
        }

        mainElem.innerHTML += productItemHTML;

        
    });

    // Check if arrows should be shown based on content width
    setTimeout(function() {
        let containerElem = mainElem.closest(".wus-product-card-options");
        if (containerElem && arrowLeftElem && arrowRightElem) {
            let containerWidth = containerElem.offsetWidth;
            let availableWidth = containerWidth - 60; // Subtract 60px for padding
            
            let allOptions = mainElem.querySelectorAll(".wus-product-card-option");
            let totalOptionsWidth = 0;
            
            allOptions.forEach(function(option) {
                totalOptionsWidth += option.offsetWidth;
            });
            
            // Show arrows if content exceeds available width
            if (totalOptionsWidth > availableWidth - 20) {
                arrowLeftElem.classList.add("show");
                arrowRightElem.classList.add("show");
            }
        }
    }, 100);

    setTimeout(function() {
        wus.handleProductCardOptionsClickEvent(mainElem);
        
        // Scroll to the active option
        let activeOption = mainElem.querySelector(".wus-product-card-option.active");
        if (activeOption) {
            let parent = activeOption.closest(".wus-product-card-options-list");
            let targetScroll = activeOption.offsetLeft;
            if (targetScroll <= 0) {
                targetScroll = 0;
            } else {
                targetScroll = targetScroll - 40;
            }
            parent.scrollTo({ left: targetScroll });
        }
    }, 50);
}

wus.handleProductCardOptionsClickEvent = function(productCardListElem) {
    if (!productCardListElem) {
        return;
    }

    productCardListElem.addEventListener("click", function(e) {
        let productCardElem = e.target.closest(".product-card");
        let productCardOptionElem = e.target.closest(".wus-product-card-option");
        
        if (!productCardOptionElem || !productCardElem) {
            return;
        }
        
        let parentListElem = productCardOptionElem.closest(".wus-product-card-options-list");

        let allItems = parentListElem.querySelectorAll(".wus-product-card-option");

        // Get data from the clicked option
        let productHandle = productCardOptionElem.getAttribute("data-product-handle");
        let productTitle = productCardOptionElem.getAttribute("data-product-title");
        let productImage1 = productCardOptionElem.getAttribute("data-product-image-1");
        let productImage2 = productCardOptionElem.getAttribute("data-product-image-2");
        let productPrice = productCardOptionElem.getAttribute("data-product-price");
        let productComparePrice = productCardOptionElem.getAttribute("data-product-compare-price");

        // Update active state
        allItems.forEach(function(item) {
            item.classList.remove("active");
        });
        productCardOptionElem.classList.add("active");

        // Update product title
        let titleLink = productCardElem.querySelector(".product-card__title a");
        if (titleLink && productTitle) {
            titleLink.textContent = productTitle;
            if (productHandle) {
                let currentHref = titleLink.getAttribute("href") || "";
                let newUrl = `/products/${productHandle}`;
                // Preserve query parameters if they exist
                if (currentHref.indexOf("?") !== -1) {
                    newUrl += currentHref.substring(currentHref.indexOf("?"));
                }
                titleLink.setAttribute("href", newUrl);
            }
        }

        // Update primary image
        let primaryImage = productCardElem.querySelector(".product-card__image--primary");
        if (primaryImage && productImage1) {
            // Generate srcset for different widths
            let widths = [200, 300, 400, 500, 600, 700, 800, 1000];
            let srcsetParts = widths.map(function(width) {
                try {
                    let imageUrl = new URL(productImage1, window.location.origin);
                    imageUrl.searchParams.set("width", width);
                    return imageUrl.href + " " + width + "w";
                } catch (e) {
                    // If URL parsing fails, try appending width parameter
                    let separator = productImage1.indexOf("?") !== -1 ? "&" : "?";
                    return productImage1 + separator + "width=" + width + " " + width + "w";
                }
            });
            
            primaryImage.setAttribute("src", productImage1);
            primaryImage.setAttribute("srcset", srcsetParts.join(", "));
            primaryImage.setAttribute("alt", productTitle || "");
        }

        // Update secondary image
        let secondaryImage = productCardElem.querySelector(".product-card__image--secondary");
        if (secondaryImage && productImage2) {
            // Generate srcset for different widths
            let widths = [200, 300, 400, 500, 600, 700, 800, 1000];
            let srcsetParts = widths.map(function(width) {
                try {
                    let imageUrl = new URL(productImage2, window.location.origin);
                    imageUrl.searchParams.set("width", width);
                    return imageUrl.href + " " + width + "w";
                } catch (e) {
                    // If URL parsing fails, try appending width parameter
                    let separator = productImage2.indexOf("?") !== -1 ? "&" : "?";
                    return productImage2 + separator + "width=" + width + " " + width + "w";
                }
            });
            
            secondaryImage.setAttribute("src", productImage2);
            secondaryImage.setAttribute("srcset", srcsetParts.join(", "));
            secondaryImage.setAttribute("alt", productTitle || "");
        }

        // Update image link href
        let imageLink = productCardElem.querySelector(".product-card__figure a");
        if (imageLink && productHandle) {
            let currentHref = imageLink.getAttribute("href") || "";
            let newUrl = `/products/${productHandle}`;
            // Preserve query parameters if they exist
            if (currentHref.indexOf("?") !== -1) {
                newUrl += currentHref.substring(currentHref.indexOf("?"));
            }
            imageLink.setAttribute("href", newUrl);
        }

        // Update quick view button data-product-handle
        let quickViewButton = productCardElem.querySelector(".product-card__quick-view-button");
        if (quickViewButton && productHandle) {
            quickViewButton.setAttribute("data-product-handle", productHandle);
        }

        // Update price
        let salePriceElem = productCardElem.querySelector("sale-price");
        if (salePriceElem && productPrice) {
            // Price from Shopify API is in cents, use directly
            let priceInCents = parseFloat(productPrice);
            // Use formatMoney if available, otherwise format manually
            if (typeof formatMoney === "function") {
                let currencyFormat = window.themeVariables && window.themeVariables.settings && 
                    window.themeVariables.settings.currencyCodeEnabled ? 
                    window.themeVariables.settings.moneyWithCurrencyFormat : 
                    (window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings.moneyFormat : "");
                let formattedPrice = formatMoney(priceInCents, currencyFormat);
                // Find and update the text content after the sr-only span
                let srOnlySpan = salePriceElem.querySelector(".sr-only");
                if (srOnlySpan && srOnlySpan.nextSibling) {
                    srOnlySpan.nextSibling.textContent = " " + formattedPrice;
                } else {
                    // Remove existing text nodes and add formatted price
                    Array.from(salePriceElem.childNodes).forEach(function(node) {
                        if (node.nodeType === Node.TEXT_NODE) {
                            node.remove();
                        }
                    });
                    if (srOnlySpan) {
                        salePriceElem.insertBefore(document.createTextNode(" " + formattedPrice), srOnlySpan.nextSibling);
                    } else {
                        salePriceElem.appendChild(document.createTextNode(formattedPrice));
                    }
                }
            } else {
                // Fallback: simple formatting (assuming price is already in display format)
                let formattedPrice = "EGP " + parseFloat(productPrice).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                let srOnlySpan = salePriceElem.querySelector(".sr-only");
                if (srOnlySpan && srOnlySpan.nextSibling) {
                    srOnlySpan.nextSibling.textContent = " " + formattedPrice;
                } else {
                    Array.from(salePriceElem.childNodes).forEach(function(node) {
                        if (node.nodeType === Node.TEXT_NODE) {
                            node.remove();
                        }
                    });
                    if (srOnlySpan) {
                        salePriceElem.insertBefore(document.createTextNode(" " + formattedPrice), srOnlySpan.nextSibling);
                    } else {
                        salePriceElem.appendChild(document.createTextNode(formattedPrice));
                    }
                }
            }
            
            // Toggle text-on-sale class based on whether there's a discount
            if (productComparePrice && parseFloat(productComparePrice) > parseFloat(productPrice)) {
                // There is a discount, add text-on-sale class
                salePriceElem.classList.add("text-on-sale");
            } else {
                // No discount (compare price same as or less than sale price, or no compare price), remove text-on-sale class
                salePriceElem.classList.remove("text-on-sale");
            }
        }

        // Update compare at price
        let comparePriceElem = productCardElem.querySelector("compare-at-price");
        if (productComparePrice) {
            if (!comparePriceElem) {
                let insertAfter = salePriceElem || productCardElem.querySelector("sale-price");
                let priceList = productCardElem.querySelector("price-list");
                let newCompare = document.createElement("compare-at-price");
                newCompare.className = "text-subdued line-through";
                let srOnlyCompare = document.createElement("span");
                srOnlyCompare.className = "sr-only";
                srOnlyCompare.textContent = "Regular price";
                newCompare.appendChild(srOnlyCompare);
                newCompare.appendChild(document.createTextNode(" "));
                if (insertAfter && insertAfter.parentNode) {
                    insertAfter.insertAdjacentElement("afterend", newCompare);
                    comparePriceElem = newCompare;
                } else if (priceList) {
                    priceList.appendChild(newCompare);
                    comparePriceElem = newCompare;
                }
            }
        } else if (comparePriceElem) {
            comparePriceElem.setAttribute("hidden", "hidden");
        }
        if (comparePriceElem && productComparePrice) {
            // Price from Shopify API is in cents, use directly
            let comparePriceInCents = parseFloat(productComparePrice);
            // Use formatMoney if available
            if (typeof formatMoney === "function") {
                let currencyFormat = window.themeVariables && window.themeVariables.settings && 
                    window.themeVariables.settings.currencyCodeEnabled ? 
                    window.themeVariables.settings.moneyWithCurrencyFormat : 
                    (window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings.moneyFormat : "");
                let formattedPrice = formatMoney(comparePriceInCents, currencyFormat);
                // Find and update the text content after the sr-only span
                let srOnlySpan = comparePriceElem.querySelector(".sr-only");
                if (srOnlySpan && srOnlySpan.nextSibling) {
                    srOnlySpan.nextSibling.textContent = " " + formattedPrice;
                } else {
                    // Remove existing text nodes and add formatted price
                    Array.from(comparePriceElem.childNodes).forEach(function(node) {
                        if (node.nodeType === Node.TEXT_NODE) {
                            node.remove();
                        }
                    });
                    if (srOnlySpan) {
                        comparePriceElem.insertBefore(document.createTextNode(" " + formattedPrice), srOnlySpan.nextSibling);
                    } else {
                        comparePriceElem.appendChild(document.createTextNode(formattedPrice));
                    }
                }
            } else {
                // Fallback: simple formatting
                let formattedPrice = "EGP " + parseFloat(productComparePrice).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                let srOnlySpan = comparePriceElem.querySelector(".sr-only");
                if (srOnlySpan && srOnlySpan.nextSibling) {
                    srOnlySpan.nextSibling.textContent = " " + formattedPrice;
                } else {
                    Array.from(comparePriceElem.childNodes).forEach(function(node) {
                        if (node.nodeType === Node.TEXT_NODE) {
                            node.remove();
                        }
                    });
                    if (srOnlySpan) {
                        comparePriceElem.insertBefore(document.createTextNode(" " + formattedPrice), srOnlySpan.nextSibling);
                    } else {
                        comparePriceElem.appendChild(document.createTextNode(formattedPrice));
                    }
                }
            }
            
            // Show/hide compare price based on whether it's greater than sale price
            if (parseFloat(productComparePrice) > parseFloat(productPrice)) {
                comparePriceElem.removeAttribute("hidden");
            } else {
                comparePriceElem.setAttribute("hidden", "hidden");
            }
        }

        // On-sale badge: create badge list / on-sale-badge when needed; sync discount text (theme locale or en/ar fallback)
        let compareNumBadge = parseFloat(productComparePrice);
        let priceNumBadge = parseFloat(productPrice);
        let isOnSaleBadge = productComparePrice && compareNumBadge > priceNumBadge && priceNumBadge > 0;
        let badgeListElem = productCardElem.querySelector(".product-card__badge-list");
        let onSaleBadgeElem = badgeListElem && badgeListElem.querySelector("on-sale-badge.badge--on-sale");
        if (!isOnSaleBadge) {
            if (onSaleBadgeElem) {
                onSaleBadgeElem.setAttribute("hidden", "hidden");
            }
        } else {
            if (!badgeListElem) {
                badgeListElem = document.createElement("div");
                badgeListElem.className = "product-card__badge-list";
                let figureForBadge = productCardElem.querySelector(".product-card__figure");
                if (figureForBadge && figureForBadge.parentNode) {
                    figureForBadge.parentNode.insertBefore(badgeListElem, figureForBadge);
                } else {
                    productCardElem.insertBefore(badgeListElem, productCardElem.firstChild);
                }
            }
            onSaleBadgeElem = badgeListElem.querySelector("on-sale-badge.badge--on-sale");
            if (!onSaleBadgeElem) {
                onSaleBadgeElem = document.createElement("on-sale-badge");
                onSaleBadgeElem.className = "badge badge--on-sale";
                badgeListElem.appendChild(onSaleBadgeElem);
            }
            let discountModeBadge = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.discountMode) || "percentage";
            onSaleBadgeElem.setAttribute("discount-mode", discountModeBadge);
            let currencyFormatBadge = window.themeVariables && window.themeVariables.settings &&
                window.themeVariables.settings.currencyCodeEnabled ?
                window.themeVariables.settings.moneyWithCurrencyFormat :
                (window.themeVariables && window.themeVariables.settings ? window.themeVariables.settings.moneyFormat : "");
            let savingsStrBadge;
            if (discountModeBadge === "percentage") {
                savingsStrBadge = Math.round((compareNumBadge - priceNumBadge) * 100 / compareNumBadge) + "%";
            } else if (typeof formatMoney === "function") {
                savingsStrBadge = formatMoney(compareNumBadge - priceNumBadge, currencyFormatBadge);
            } else {
                savingsStrBadge = "EGP " + ((compareNumBadge - priceNumBadge) / 100).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            }
            let badgeLabelHtml;
            if (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.discountBadge) {
                badgeLabelHtml = window.themeVariables.strings.discountBadge.replace("@@", savingsStrBadge);
            } else if (typeof Shopify !== "undefined" && Shopify.locale === "ar") {
                badgeLabelHtml = "وفر " + savingsStrBadge;
            } else {
                badgeLabelHtml = "Save " + savingsStrBadge;
            }
            onSaleBadgeElem.removeAttribute("hidden");
            onSaleBadgeElem.innerHTML = badgeLabelHtml;
        }
    });
}

wus.setMainProductTemplateId = async function() {
    try {
        let url = "/products/retail-squeeze-ball";
        let response = await fetch(url);
        let html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        let mainElem = doc.getElementById("main")
        let templateElem = mainElem.querySelector(".shopify-section--main-product");
        if (!templateElem) {
            return;
        }
        let templateId = templateElem.getAttribute("id");
        let productTemplateId = templateId.replace("shopify-section-", "");
        window.MAIN_PRODUCT_TEMPLATE_ID = productTemplateId.trim();
    } catch(e) {
        console.error("[WUS-ERROR] Error setting main product template id: ", e)
        window.MAIN_PRODUCT_TEMPLATE_ID = null;
    }   
}

wus.showHideQuickButtons = function(action) {
    let quickButtonsElems = document.querySelector(".wus-atc-product-buttons");

    if (window.innerWidth > 999) {
        return;
    }

    if (!quickButtonsElems) {
        return;
    }

    if (action === "show") {
        quickButtonsElems.style["display"] = "block";
        setTimeout(function() {
            quickButtonsElems.style["opacity"] = "1";
        }, 100);
    } else {
        quickButtonsElems.style["opacity"] = "0";
        setTimeout(function() {
            quickButtonsElems.style["display"] = "none";
        }, 200);
    }
}

wus.handleProductQuickBuyButtons = function() {
    if (!wus.isProductPage()) {
        return;
    }

    let fcInterval = null;

    let addToCartButton = document.querySelector(".wus-atc-product-button-add-to-cart");
    let buyItNowButton = document.querySelector(".wus-atc-product-button-buy-it-now");

    if (!addToCartButton || !buyItNowButton) {
        return;
    }

    let targetButton = document.querySelector(".product-info__buy-buttons form[action='/cart/add'] buy-buttons button[type=submit]");

    if (targetButton) {
        observeInViewport(targetButton, {
            onAppear: function() {
                console.log("target button appeared");
                wus.showHideQuickButtons("hide");
            },
            onDisappear: function() {
                console.log("target button disappeared");
                wus.showHideQuickButtons("show");
            }
        });
    }

    addToCartButton.addEventListener("click", function() {
        let self = this;
        let realAddToCartButton = document.querySelector(".product-info__buy-buttons form[action='/cart/add'] buy-buttons button[type=submit]");
        if (!realAddToCartButton) {
            return;
        }
        realAddToCartButton.click();
        this.classList.add("loading");
        setTimeout(function() {
            self.classList.remove("loading");
        }, 2000);
    });

    buyItNowButton.addEventListener("click", function() {
        let self = this;
        let realBuyItNowButton = document.querySelector(".product-info__buy-buttons form[action='/cart/add'] buy-buttons shopify-accelerated-checkout shopify-buy-it-now-button button.shopify-payment-button__button");

        if (!realBuyItNowButton) {
            realBuyItNowButton = document.querySelector(".product-info__buy-buttons form[action='/cart/add'] buy-buttons .shopify-payment-button__more-options");
        }

        if (!realBuyItNowButton) {
            return;
        }
        console.log(realBuyItNowButton)
        realBuyItNowButton.click();
        this.classList.add("loading");
        setTimeout(function() {
            self.classList.remove("loading");
        }, 2000);
    });

    fcInterval = setInterval(function() {
        let fcElem = document.querySelector("#fc_frame #fc_widget");

        if (!fcElem) {
            return;
        }
        
        clearInterval(fcInterval);
        
        function shrinkQuickButtons() {
            let mainQuickButtonsElem = document.querySelector(".wus-atc-product-buttons");
            if (mainQuickButtonsElem) {
                mainQuickButtonsElem.classList.add("shrink")
            }
        }

        let tempTimeout = null;

        setTimeout(function() {
            shrinkQuickButtons()
            clearTimeout(tempTimeout);
            tempTimeout = null;
        }, 10 * 1000)

        fcElem.addEventListener("load", function() {
            shrinkQuickButtons()
            clearTimeout(tempTimeout);
            tempTimeout = null;
        });

        
    }, 20)
}

wus.updatePaginationUrls = function() {
    const paginationLinks = document.querySelectorAll('.pagination__item[data-page]');
    
    if (paginationLinks.length === 0) return;
    
    paginationLinks.forEach(function(link) {
      const pageNumber = link.getAttribute('data-page');
      const url = new URL(window.location.href);
      
      // Remove or update the page parameter
      if (pageNumber === '1') {
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('page', pageNumber);
      }
      
      // Update the href
      link.href = url.toString();
    });
}

wus.handlePaginationUrls = function() {
    const paginationLinks = document.querySelectorAll('.pagination__item[data-page]');
    if (paginationLinks.length === 0) return;

    wus.updatePaginationUrls()

    setInterval(function() {
        wus.updatePaginationUrls()
    }, 1000)
}

wus.run = function() {
    if (!this.canRun()) {
        setTimeout(function() {
            wus.run()
        }, 100)

        return
    }
    
    wus.runCommons()
    wus.runProductPage()
    wus.runHomePage()
    wus.runCollectionPage()
}

wus.fire()